<template>
    <div>
        <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
            <!-- 탭 헤더 -->
            <v-toolbar color="grey lighten-5" flat class="elevation-1" dense>
                <!-- PC: 탭 / 모바일: 드롭다운 -->
                <v-tabs
                    v-if="!isMobileTab"
                    v-model="activeTab"
                    color="primary"
                    slider-color="primary"
                    background-color="transparent"
                    icons-and-text
                    class="flex-grow-1"
                    show-arrows
                >
                    <v-tab v-for="tab in tabItems" :key="tab.value" class="tab-item">
                        <span class="tab-text">{{ tab.text }}</span>
                        <v-icon class="ml-2" size="20">{{ tab.icon }}</v-icon>
                    </v-tab>
                </v-tabs>
                <v-select
                    v-else
                    v-model="activeTab"
                    :items="tabItems"
                    item-text="text"
                    item-value="value"
                    dense
                    outlined
                    hide-details
                    color="primary"
                    class="tab-select flex-grow-1 my-2"
                    :menu-props="{ offsetY: true, maxHeight: 400 }"
                >
                    <template v-slot:selection="{ item }">
                        <v-icon size="18" color="primary" class="mr-2">{{ item.icon }}</v-icon>
                        <span class="tab-text">{{ item.text }}</span>
                    </template>
                    <template v-slot:item="{ item, on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on">
                            <v-list-item-icon class="mr-3">
                                <v-icon size="20" color="primary">{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-select>
                <v-spacer></v-spacer>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            :href="url"
                            target="_blank"
                            rel="noopener noreferrer"
                            color="lime accent-3"
                            rounded
                            elevation="2"
                            x-small
                            class="mr-2"
                        >
                            <v-icon left color="black" small>mdi-open-in-new</v-icon>
                            <span style="color:black; font-size:12px">링크 열기</span>
                        </v-btn>
                    </template>
                    <span>새 탭에서 서버 상태 JSON 열기</span>
                </v-tooltip>
            </v-toolbar>

            <!-- 탭 패널 -->
            <v-tabs-items v-model="activeTab" :touchless="isMobileTab">
                <!-- 탭 1: 일반설정 -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom">
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-cog</v-icon>
                            <span class="toolbar-text">일반 서버 설정</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-list class="pa-0">
                        <div v-for="(section, sectionIdx) in fieldConfig.filter(s => s.tab === 'general')" :key="`section-${sectionIdx}`">
                    <v-list-item class="section-header" style="background:#E3F2FD; min-height: 48px;">
                        <v-list-item-content>
                            <v-list-item-title class="text-h6 font-weight-bold">{{ section.title }}</v-list-item-title>
                        </v-list-item-content>
                </v-list-item>
                <v-divider/>

                    <!-- 필드 그룹 (한 행에 여러 필드) -->
                    <div v-for="(group, groupIdx) in section.groups" :key="`group-${sectionIdx}-${groupIdx}`">
                        <v-list-item class="px-4 py-1" style="min-height: auto;">
                            <v-row class="align-center" no-gutters>
                                <!-- 왼쪽 타이틀 (group.title이 있는 경우) -->
                                <v-col v-if="group.title" cols="12" md="2" class="pa-1 d-flex align-center" style="min-width: 80px; flex-shrink: 0;">
                                    <div class="text-subtitle-2 font-weight-medium">{{ group.title }}</div>
                                </v-col>
                                <!-- 필드들 -->
                                <v-col 
                                    v-for="(field, fieldIdx) in group.fields"
                                    :key="`field-${sectionIdx}-${groupIdx}-${fieldIdx}`"
                                    :cols="12"
                                    :md="group.title ? (field.cols || 10) : (field.cols || 12)" 
                                    class="pa-1"
                                >
                                    <v-text-field
                                        v-if="field.type === 'text'"
                                        :label="field.label"
                                        :placeholder="field.placeholder || ''"
                                        v-model="fieldData[field.jsonKey]"
                                        outlined
                                        dense
                                        hide-details
                                        :class="{'mb-0': true, 'check-version-field': field.isCheckVersion}"
                                        :style="field.isMinVersion ? 'background-color: #E53935;' : (field.isCheckVersion ? 'background-color: #BBDEFB;' : '')"
                                        :dark="field.isMinVersion === true"
                                    />
                        <v-select
                                        v-else-if="field.type === 'select'"
                                        :label="field.label"
                                        v-model="fieldData[field.jsonKey]"
                                        :items="getOptions(field.options)"
                            item-text="name"
                            item-value="value"
                                        outlined
                                        dense
                                        hide-details
                            @change="Refresh_ItemInfo"
                                        :class="{'mb-0': true, 'check-version-field': field.isCheckVersion}"
                                        :style="field.isMinVersion ? 'background-color: #E53935;' : (field.isCheckVersion ? 'background-color: #BBDEFB;' : '')"
                                        :dark="field.isMinVersion === true"
                                    />
                                    <v-textarea
                                        v-else-if="field.type === 'textarea'"
                                        :label="field.label"
                                        :placeholder="field.placeholder || ''"
                                        v-model="fieldData[field.jsonKey]"
                                        outlined
                                        dense
                                        :rows="field.rows || 3"
                                        hide-details
                                        :class="{'mb-0': true, 'check-version-field': field.isCheckVersion}"
                                        :style="field.isMinVersion ? 'background-color: #E53935;' : (field.isCheckVersion ? 'background-color: #BBDEFB;' : '')"
                                        :dark="field.isMinVersion === true"
                                    />
                                </v-col>
                            </v-row>
                </v-list-item>
                        <v-divider v-if="groupIdx < section.groups.length - 1" class="mx-4"/>
                    </div>
                    
                    <!-- 점검 메시지 필드 (서버 점검 상태 섹션에만 표시) -->
                    <v-list-item v-if="section.title.includes('서버 점검 상태') && IsSever_Checking()" class="px-4 py-1" style="min-height: auto;">
                        <v-col cols="12" class="pa-1">
                    <v-text-field
                                label="점검 메시지"
                                placeholder="점검시간동안 노출될 메시지를 입력해주세요."
                                v-model="fieldData.SERVER_CHECKING_MSG"
                                outlined
                                dense
                                hide-details
                                class="mb-0"
                            />
                        </v-col>
                </v-list-item>

                    <v-divider class="my-1"/>
                        </div>
                    </v-list>
                </v-tab-item>

                <!-- 탭 2: 이벤트설정 (리뷰이벤트 링크 설정 + 이벤트 설정) -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom">
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-star</v-icon>
                            <span class="toolbar-text">이벤트 설정</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-list class="pa-0">
                        <!-- 리뷰이벤트 링크 설정 섹션 -->
                        <div v-for="(section, sectionIdx) in fieldConfig.filter(s => s.tab === 'event')" :key="`section-event-${sectionIdx}`">
                            <v-list-item class="section-header" style="background:#E3F2FD; min-height: 48px;">
                                <v-list-item-content>
                                    <v-list-item-title class="text-h6 font-weight-bold">{{ section.title }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider/>
                            <div v-for="(group, groupIdx) in section.groups" :key="`group-${sectionIdx}-${groupIdx}`">
                                <v-list-item class="px-4 py-1" style="min-height: auto;">
                                    <v-row class="align-center" no-gutters>
                                        <v-col v-if="group.title" cols="12" md="2" class="pa-1 d-flex align-center" style="min-width: 80px; flex-shrink: 0;">
                                            <div class="text-subtitle-2 font-weight-medium">{{ group.title }}</div>
                                        </v-col>
                                        <v-col v-for="(field, fieldIdx) in group.fields" :key="`field-${fieldIdx}`" :cols="12" :md="group.title ? (field.cols || 10) : (field.cols || 12)" class="pa-1">
                                            <v-text-field v-if="field.type === 'text'" :label="field.label" :placeholder="field.placeholder || ''" v-model="fieldData[field.jsonKey]" :disabled="field.disabled === true" outlined dense hide-details class="mb-0" />
                                            <v-select v-else-if="field.type === 'select'" :label="field.label" v-model="fieldData[field.jsonKey]" :items="getOptions(field.options)" item-text="name" item-value="value" outlined dense hide-details @change="Refresh_ItemInfo" class="mb-0" />
                                        </v-col>
                                    </v-row>
                                </v-list-item>
                            </div>
                            <v-divider class="my-1"/>
                        </div>

                        <!-- 스탬프 이벤트 설정 (TYR / MAF) — 서버에 'Y'/'N' 으로 저장 -->
                        <v-list-item class="section-header" style="background:#FFF3E0; min-height: 48px;">
                            <v-list-item-content>
                                <v-list-item-title class="text-h6 font-weight-bold">[ 스탬프 이벤트 설정 ]</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>
                        <v-list-item class="px-4 py-2">
                            <v-row no-gutters class="align-center">
                                <v-col cols="12" md="6" class="pa-2 d-flex align-center">
                                    <v-switch
                                        :input-value="enable_stamp_event_tyr === 'Y'"
                                        @change="(v) => enable_stamp_event_tyr = v ? 'Y' : 'N'"
                                        inset dense hide-details color="primary"
                                        class="mt-0"
                                    ></v-switch>
                                    <div class="ml-2">
                                        <div class="text-body-2 font-weight-bold">스탬프 이벤트 TYR</div>
                                        <div class="text-caption grey--text">ENABLE_STAMP_EVENT_TYR · 현재 값: <code>{{ enable_stamp_event_tyr }}</code></div>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6" class="pa-2 d-flex align-center">
                                    <v-switch
                                        :input-value="enable_stamp_event_maf === 'Y'"
                                        @change="(v) => enable_stamp_event_maf = v ? 'Y' : 'N'"
                                        inset dense hide-details color="primary"
                                        class="mt-0"
                                    ></v-switch>
                                    <div class="ml-2">
                                        <div class="text-body-2 font-weight-bold">스탬프 이벤트 MAF</div>
                                        <div class="text-caption grey--text">ENABLE_STAMP_EVENT_MAF · 현재 값: <code>{{ enable_stamp_event_maf }}</code></div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-divider/>

                        <!-- 데일리 이벤트 카운트 설정 -- 일일 오퍼월 챌린지 카운트 설정 -->
                        <v-list-item class="section-header" style="background:#FFF3E0; min-height: 48px;">
                            <v-list-item-content>
                                <v-list-item-title class="text-h6 font-weight-bold">[ 데일리 이벤트 카운트 설정 ]</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>
                        <v-list-item class="px-4 py-2">
                            <v-row no-gutters class="align-center">
                                <v-col cols="12" md="6" class="pa-2">
                                    <v-text-field
                                        v-model.number="daily_offerwall_challenge_count"
                                        type="number"
                                        min="0"
                                        label="일일 오퍼월 챌린지 카운트"
                                        outlined dense hide-details
                                        prepend-inner-icon="mdi-counter"
                                    ></v-text-field>
                                    <div class="text-caption grey--text mt-1">DAILY_OFFERWALL_CHALLENGE_COUNT · 현재 값: <code>{{ daily_offerwall_challenge_count }}</code></div>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-divider/>

                        <!-- 이벤트 썸네일 리스트 -->
                        <v-list-item class="section-header" style="background:#E3F2FD; min-height: 48px;">
                            <v-list-item-content>
                                <v-list-item-title class="text-h6 font-weight-bold">[ 이벤트 설정 ]</v-list-item-title>
                            </v-list-item-content>
                    <v-list-item-action>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="primary"
                                    small
                                    fab
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="addEventThumbItem"
                                >
                                    <v-icon color="white">mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <span>이벤트 썸네일 항목 추가</span>
                        </v-tooltip>
                    </v-list-item-action>
                </v-list-item>
                <v-divider/>

                <v-list-item
                    v-for="(item, idx) in event_thumb_list"
                    :key="idx"
                    class="px-4 py-2"
                    style="min-height: auto;"
                >
                    <v-row no-gutters class="align-center">
                        <v-col cols="12" md="1" class="pa-1">
                            <div v-if="item.thumb" class="mt-1">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <img 
                                            :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+item.thumb" 
                                            alt="Image"
                                            v-bind="attrs"
                                            v-on="on"
                                            style="width: 40px; height: 40px; border: 2px solid #E0E0E0; border-radius: 4px; object-fit: cover; display: block; cursor: pointer;"
                                        />
                                    </template>
                                    <img 
                                        :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+item.thumb" 
                                        alt="Image Preview"
                                        style="width: 200px; height: 200px; border: 2px solid #E0E0E0; border-radius: 8px; object-fit: cover; display: block;"
                                    />
                                </v-tooltip>
                            </div>
                        </v-col>
                        <v-col cols="12" md="3" class="pa-1">
                            <div class="text-body-2 font-weight-medium">{{ item.title || '(제목 없음)' }}</div>
                            <div class="text-caption text--secondary">{{ item.location === 'main' ? '메인' : item.location === 'admin_notice' ? '운영자공지' : '' }}</div>
                        </v-col>
                        <v-col cols="12" md="3" class="pa-1">
                            <div class="text-caption">{{ typeLabelFor(item.type) }}</div>
                            <div class="text-body-2">{{ item.param || '-' }}</div>
                            <div v-if="item.type === 'campaign' && item.sub_param" class="text-caption grey--text">sub: {{ item.sub_param }}</div>
                        </v-col>
                        <v-col cols="12" md="4" class="pa-1">
                            <div class="text-body-2">{{ item.desc || '-' }}</div>
                        </v-col>
                        <v-col cols="12" md="1" class="pa-1 d-flex align-center justify-end">
                            <v-btn
                                color="primary"
                                x-small
                                fab
                                @click="openEventThumbDialog(idx)"
                                class="mr-1"
                            >
                                <v-icon color="white" small>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                                color="error"
                                x-small
                                fab
                                @click="removeEventThumbItem(idx)"
                            >
                                <v-icon color="white" small>mdi-delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-list-item>
                <v-divider class="my-1"/>

                <!-- 이벤트 썸네일 편집 다이얼로그 -->
                <v-dialog v-model="eventThumbDialog" max-width="600" :fullscreen="$vuetify.breakpoint.xsOnly">
                    <v-card>
                        <v-card-title class="text-h5">
                            {{ eventThumbEditIndex === -1 ? '이벤트 추가' : '이벤트 편집' }}
                        </v-card-title>
                        <v-divider/>
                        <v-card-text class="pa-4">
                            <v-text-field
                                label="타이틀 *"
                                v-model="eventThumbDialogData.title"
                                outlined
                                dense
                                class="mb-2"
                            />
                            <v-textarea
                                label="설명"
                                v-model="eventThumbDialogData.desc"
                                outlined
                                rows="3"
                                class="mb-2"
                            />
                            <v-select
                                label="공개위치 *"
                                v-model="eventThumbDialogData.location"
                                :items="eventLocationOptions"
                                item-text="name"
                                item-value="value"
                                outlined
                                dense
                                class="mb-2"
                            />
                            <v-file-input
                                label="썸네일 (128x128)"
                                accept="image/*"
                                prepend-icon="mdi-image"
                                outlined
                                dense
                                v-model="eventThumbDialogTempFile"
                                @change="(file) => eventThumbDialogTempFile = file"
                                class="mb-2"
                            />
                            <div v-if="eventThumbDialogData.thumb && !eventThumbDialogTempFile" class="mb-2">
                                <img 
                                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+eventThumbDialogData.thumb" 
                                    alt="Image"
                                    style="width: 80px; height: 80px; border: 2px solid #E0E0E0; border-radius: 8px; object-fit: cover;"
                                />
                            </div>
                            <v-select
                                label="타입 *"
                                v-model="eventThumbDialogData.type"
                                :items="eventThumbTypeOptions"
                                item-text="name"
                                item-value="value"
                                outlined
                                dense
                                class="mb-2"
                            />
                            <v-text-field
                                :label="paramLabelFor(eventThumbDialogData.type)"
                                :placeholder="paramPlaceholderFor(eventThumbDialogData.type)"
                                v-model="eventThumbDialogData.param"
                                outlined
                                dense
                                class="mb-2"
                            />
                            <!-- 캠페인 타입일 때만 추가 파라미터 노출 -->
                            <v-text-field
                                v-if="eventThumbDialogData.type === 'campaign'"
                                label="추가 파라미터 (sub_param)"
                                placeholder="예: 플레이스먼트 키"
                                v-model="eventThumbDialogData.sub_param"
                                hint="캠페인 액션 실행 시 함께 전달할 부가 파라미터. 비워두면 미사용."
                                persistent-hint
                                outlined
                                dense
                            />
                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn text @click="closeEventThumbDialog">취소</v-btn>
                            <v-btn color="primary" @click="saveEventThumbDialog">저장</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                    </v-list>
                </v-tab-item>

                <!-- 탭 3: 환율설정 -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom">
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-currency-usd</v-icon>
                            <span class="toolbar-text">환율 설정</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-list class="pa-0">
                        <div v-for="(section, sectionIdx) in fieldConfig.filter(s => s.tab === 'exchange')" :key="`section-exchange-${sectionIdx}`">
                            <v-list-item class="section-header" style="background:#E3F2FD; min-height: 48px;">
                                <v-list-item-content>
                                    <v-list-item-title class="text-h6 font-weight-bold">{{ section.title }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider/>
                            <div v-for="(group, groupIdx) in section.groups" :key="`group-${sectionIdx}-${groupIdx}`">
                                <v-list-item class="px-4 py-1" style="min-height: auto;">
                                    <v-row class="align-center" no-gutters>
                                        <v-col v-if="group.title" cols="12" md="2" class="pa-1 d-flex align-center" style="min-width: 80px; flex-shrink: 0;">
                                            <div class="text-subtitle-2 font-weight-medium">{{ group.title }}</div>
                                        </v-col>
                                        <v-col v-for="(field, fieldIdx) in group.fields" :key="`field-${fieldIdx}`" :cols="12" :md="group.title ? (field.cols || 10) : (field.cols || 12)" class="pa-1">
                                            <v-text-field v-if="field.type === 'text'" :label="field.label" :placeholder="field.placeholder || ''" v-model="fieldData[field.jsonKey]" :disabled="field.disabled === true" outlined dense hide-details class="mb-0" />
                                        </v-col>
                                    </v-row>
                                </v-list-item>
                            </div>
                            <v-divider class="my-1"/>
                        </div>
                    </v-list>
                </v-tab-item>
                <!-- 탭 4: 데이터 관리 -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom">
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-database</v-icon>
                            <span class="toolbar-text">데이터 관리</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-list class="pa-0">
                        <!-- 부스터 퀘스트 섹션 -->
                        <v-list-item class="section-header" style="background:#E3F2FD; min-height: 48px;">
                            <v-list-item-content>
                                <v-list-item-title class="text-h6 font-weight-bold">[ 부스터 퀘스트 ]</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>

                        <v-list-item class="px-4 py-3">
                            <v-row class="align-center" no-gutters>
                                <v-col cols="12" md="6" class="pa-1">
                                    <v-file-input
                                        label="booster_quest.json 파일업로드"
                                        v-model="boosterQuestFile"
                                        :multiple="false"
                                        accept=".json,application/json"
                                        outlined
                                        dense
                                        hide-details
                                        @change="onFileChange_BoosterQuest"
                                    />
                                </v-col>
                                <v-col cols="12" md="6" class="pa-1 d-flex align-center">
                                    <v-btn
                                        color="blue-grey darken-1"
                                        dark
                                        small
                                        @click="openBoosterQuestLink"
                                        class="mr-2"
                                    >
                                        <v-icon left small>mdi-open-in-new</v-icon>
                                        링크 보기
                                    </v-btn>
                                    <v-btn
                                        v-if="enableUpload_BoosterQuest"
                                        color="lime accent-3"
                                        @click="upload_BoosterQuest"
                                        :loading="loadingBoosterQuest"
                                    >
                                        <v-icon left>mdi-upload</v-icon>
                                        업로드
                                    </v-btn>
                                    <v-btn v-else color="grey" style="color: white; font-weight: 700;" disabled>
                                        <v-icon left>mdi-upload</v-icon>
                                        업로드
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-divider class="my-1"/>

                        <!-- 부스터 퀘스트 V2 (booster_quest_v2.json) — 신규 포맷 -->
                        <v-list-item class="px-4 py-3">
                            <v-row class="align-center" no-gutters>
                                <v-col cols="12" md="6" class="pa-1">
                                    <v-file-input
                                        label="booster_quest_v2.json 파일업로드 (V2)"
                                        v-model="boosterQuestFileV2"
                                        :multiple="false"
                                        accept=".json,application/json"
                                        outlined
                                        dense
                                        hide-details
                                        prepend-icon="mdi-file-document-multiple-outline"
                                        @change="onFileChange_BoosterQuestV2"
                                    />
                                </v-col>
                                <v-col cols="12" md="6" class="pa-1 d-flex align-center">
                                    <v-btn
                                        color="blue-grey darken-1"
                                        dark
                                        small
                                        @click="openBoosterQuestLinkV2"
                                        class="mr-2"
                                    >
                                        <v-icon left small>mdi-open-in-new</v-icon>
                                        링크 보기 (V2)
                                    </v-btn>
                                    <v-btn
                                        v-if="enableUpload_BoosterQuestV2"
                                        color="lime accent-3"
                                        @click="upload_BoosterQuestV2"
                                        :loading="loadingBoosterQuestV2"
                                    >
                                        <v-icon left>mdi-upload</v-icon>
                                        업로드 (V2)
                                    </v-btn>
                                    <v-btn v-else color="grey" style="color: white; font-weight: 700;" disabled>
                                        <v-icon left>mdi-upload</v-icon>
                                        업로드 (V2)
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-divider class="my-1"/>

                        <!--
                            부스터 퀘스트 오퍼월 타입 키 리스트
                            - 퀘스트 상태가 오퍼월임을 클라이언트에 알리기 위한 타입 목록
                            - 클라이언트는 해당 타입에 해당하는 퀘스트 상태일 때만 서버에 갱신 요청을 보내므로
                              불필요한 서버 호출을 줄여 서버 부담을 경감시킴
                        -->
                        <v-list-item class="section-header" style="background:#E3F2FD; min-height: 48px;">
                            <v-list-item-content>
                                <v-list-item-title class="text-h6 font-weight-bold">[ 부스터 퀘스트 오퍼월 타입 ]</v-list-item-title>
                                <v-list-item-subtitle class="text-caption grey--text">
                                    퀘스트 상태가 오퍼월임을 클라이언트에 알려, 해당 상태일 때만 갱신하여 서버 부담을 줄이기 위한 타입 리스트
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>

                        <v-list-item class="px-4 py-3">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-row class="align-center mb-2" no-gutters>
                                        <v-col cols="12" md="6" class="pa-1">
                                            <v-text-field
                                                label="타입 키 입력"
                                                placeholder="예: rewarded_video"
                                                v-model="newOfferwallType"
                                                outlined
                                                dense
                                                hide-details
                                                @keyup.enter="addOfferwallType"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="2" class="pa-1">
                                            <v-btn
                                                color="primary"
                                                small
                                                @click="addOfferwallType"
                                                :disabled="!newOfferwallType || !newOfferwallType.trim()"
                                            >
                                                <v-icon left small>mdi-plus</v-icon>
                                                추가
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-chip
                                        v-for="(item, idx) in boosterQuestOfferwallTypes"
                                        :key="'offerwall-type-' + idx"
                                        close
                                        class="ma-1"
                                        color="blue-grey lighten-4"
                                        @click:close="removeOfferwallType(idx)"
                                    >
                                        {{ item }}
                                    </v-chip>
                                    <div v-if="boosterQuestOfferwallTypes.length === 0" class="grey--text text--lighten-1 pa-2">
                                        등록된 타입이 없습니다.
                                    </div>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-divider class="my-1"/>
                    </v-list>
                </v-tab-item>

                <!-- ===== 탭 5: 충전소 관리 ===== -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom">
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-power-plug</v-icon>
                            <span class="toolbar-text">충전소 관리</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-chip small class="mr-2" color="amber lighten-4" text-color="brown darken-2">
                            <v-icon left x-small>mdi-star</v-icon>
                            상단 {{ OFFERWALL_TOP_COUNT }}개 활성 노출
                        </v-chip>
                        <v-btn color="primary" small @click="openOfferwallDialog">
                            <v-icon left small>mdi-plus</v-icon>충전소 추가
                        </v-btn>
                    </v-toolbar>

                    <v-list class="pa-0">
                        <v-list-item class="section-header" style="background:#FFF8E1; min-height: 48px;">
                            <v-list-item-content>
                                <v-list-item-title class="text-h6 font-weight-bold">[ 충전소 리스트 (드래그로 순서 변경) ]</v-list-item-title>
                                <v-list-item-subtitle class="text-caption grey--text">
                                    상단 {{ OFFERWALL_TOP_COUNT }}개 항목은 아이보리 배경으로 활성화 표시되며, 나머지는 "더보기" 버튼으로 펼쳐서 관리합니다.
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>

                        <v-list-item class="px-4 py-3">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <draggable
                                        v-model="offerwall_list"
                                        handle=".drag-handle"
                                        @end="onOfferwallDragEnd"
                                    >
                                        <v-list-item
                                            v-for="(item, index) in offerwall_list"
                                            v-show="showAllOfferwalls || index < OFFERWALL_TOP_COUNT"
                                            :key="item.tag || ('offerwall-' + index)"
                                            :style="getOfferwallItemStyle(item, index)"
                                            class="mb-2"
                                        >
                                            <v-icon class="drag-handle mr-2" :color="item.is_active === 'Y' ? 'brown darken-1' : 'grey lighten-1'">mdi-drag</v-icon>
                                            <v-avatar size="40" class="mr-3" tile>
                                                <img
                                                    v-if="item.icon"
                                                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + item.icon"
                                                    alt="icon"
                                                    style="object-fit: cover; border: 1px solid #ddd; border-radius: 4px;"
                                                />
                                                <v-icon v-else size="32" color="grey lighten-1">mdi-image-off-outline</v-icon>
                                            </v-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title :class="{'grey--text text--darken-1': item.is_active !== 'Y'}">
                                                    <span class="font-weight-bold">{{ item.name || '(이름 없음)' }}</span>
                                                    <v-chip
                                                        v-if="index < OFFERWALL_TOP_COUNT"
                                                        x-small
                                                        color="amber lighten-3"
                                                        text-color="brown darken-3"
                                                        class="ml-2"
                                                    >
                                                        <v-icon left x-small>mdi-star</v-icon>활성
                                                    </v-chip>
                                                    <v-chip
                                                        v-if="isOfferwallEventActiveNow(item)"
                                                        x-small
                                                        color="pink lighten-4"
                                                        text-color="pink darken-3"
                                                        class="ml-1"
                                                    >
                                                        <v-icon left x-small>mdi-calendar-star</v-icon>이벤트
                                                    </v-chip>
                                                    <v-chip
                                                        v-else-if="item.is_event_mode === 'Y'"
                                                        x-small
                                                        color="grey lighten-2"
                                                        text-color="grey darken-1"
                                                        class="ml-1"
                                                    >
                                                        <v-icon left x-small>mdi-calendar-remove</v-icon>기간외
                                                    </v-chip>
                                                </v-list-item-title>
                                                <v-list-item-subtitle :class="{'grey--text': item.is_active !== 'Y'}">
                                                    태그: {{ item.tag || '-' }} |
                                                    상태: {{ item.is_active === 'Y' ? '활성화' : '비활성화' }} |
                                                    이벤트: {{ isOfferwallEventActiveNow(item) ? 'ON' : 'OFF' }}<template v-if="item.is_event_mode === 'Y' && !isOfferwallEventActiveNow(item)"> (기간외)</template><template v-if="item.is_event_mode === 'Y' && (item.event_start || item.event_end)"> | 기간: {{ formatOfferwallEventPeriod(item) }}</template>
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action class="d-flex flex-row align-center" style="min-width: 200px;">
                                                <v-btn
                                                    icon
                                                    small
                                                    @click="toggleOfferwallEventMode(index)"
                                                    :color="item.is_event_mode === 'Y' ? 'pink' : 'grey'"
                                                    :title="item.is_event_mode === 'Y' ? '이벤트 모드 ON' : '이벤트 모드 OFF'"
                                                >
                                                    <v-icon>{{ item.is_event_mode === 'Y' ? 'mdi-calendar-star' : 'mdi-calendar-blank-outline' }}</v-icon>
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    small
                                                    @click="toggleOfferwallActive(index)"
                                                    :color="item.is_active === 'Y' ? 'success' : 'grey'"
                                                    :title="item.is_active === 'Y' ? '활성화됨' : '비활성화됨'"
                                                >
                                                    <v-icon>{{ item.is_active === 'Y' ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                                                </v-btn>
                                                <v-btn icon small color="primary" @click="editOfferwall(index)" title="수정">
                                                    <v-icon>mdi-pencil</v-icon>
                                                </v-btn>
                                                <v-btn icon small color="red" @click="deleteOfferwall(index)" title="삭제">
                                                    <v-icon>mdi-delete</v-icon>
                                                </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </draggable>

                                    <v-container v-if="offerwall_list.length === 0" class="text-center py-8">
                                        <v-icon large color="grey lighten-1" class="mb-3">mdi-information-outline</v-icon>
                                        <p class="text-body-2 grey--text">등록된 충전소가 없습니다. 우측 상단의 "충전소 추가" 버튼을 눌러 등록하세요.</p>
                                    </v-container>

                                    <div
                                        v-if="offerwall_list.length > OFFERWALL_TOP_COUNT"
                                        class="text-center mt-3"
                                    >
                                        <v-btn
                                            text
                                            small
                                            color="primary"
                                            @click="showAllOfferwalls = !showAllOfferwalls"
                                        >
                                            <v-icon left small>{{ showAllOfferwalls ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                            {{ showAllOfferwalls ? '비활성 항목 접기' : `비활성 항목 ${offerwall_list.length - OFFERWALL_TOP_COUNT}개 더보기` }}
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-divider class="my-1"/>
                    </v-list>
                </v-tab-item>

                <!-- ===== 탭 6: 충전소 탭 관리 ===== -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom">
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-tab</v-icon>
                            <span class="toolbar-text">충전소 탭 관리</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" small @click="openChargeTabDialog">
                            <v-icon left small>mdi-plus</v-icon>탭 추가
                        </v-btn>
                    </v-toolbar>

                    <v-list class="pa-0">
                        <v-list-item class="section-header" style="background:#E8F5E9; min-height: 48px;">
                            <v-list-item-content>
                                <v-list-item-title class="text-h6 font-weight-bold">[ 충전소 탭 리스트 (드래그로 순서 변경) ]</v-list-item-title>
                                <v-list-item-subtitle class="text-caption grey--text">
                                    PLACEMENT_BIG / PLACEMENT_NORMAL 은 이름·플레이스먼트 키·아이콘으로 등록하고, OFFERWALL 은 "충전소 관리" 탭에 등록된 항목을 선택해 추가합니다.
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>

                        <v-list-item class="px-4 py-3">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <draggable
                                        v-model="charge_tab_list"
                                        handle=".drag-handle"
                                        @end="onChargeTabDragEnd"
                                    >
                                        <v-list-item
                                            v-for="(item, index) in charge_tab_list"
                                            :key="('charge-tab-' + index)"
                                            :style="getChargeTabItemStyle(item)"
                                            class="mb-2"
                                        >
                                            <v-icon class="drag-handle mr-2" color="grey darken-1">mdi-drag</v-icon>
                                            <v-avatar size="40" class="mr-3" tile>
                                                <img
                                                    v-if="item.type === 'OFFERWALL' && getChargeTabIcon(item)"
                                                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + getChargeTabIcon(item)"
                                                    alt="icon"
                                                    style="object-fit: cover; border: 1px solid #ddd; border-radius: 4px;"
                                                />
                                                <v-icon v-else size="28" :color="getChargeTabTypeColor(item.type)">
                                                    {{ item.type === 'PLACEMENT_BIG' ? 'mdi-bookmark-box-multiple-outline' : item.type === 'PLACEMENT_NORMAL' ? 'mdi-bookmark-outline' : 'mdi-image-off-outline' }}
                                                </v-icon>
                                            </v-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <v-chip
                                                        x-small
                                                        :color="getChargeTabTypeColor(item.type)"
                                                        text-color="white"
                                                        class="mr-2"
                                                    >
                                                        {{ item.type }}
                                                    </v-chip>
                                                    <span class="font-weight-bold">{{ getChargeTabName(item) || '(이름 없음)' }}</span>
                                                </v-list-item-title>
                                                <v-list-item-subtitle class="grey--text">
                                                    <template v-if="item.type === 'OFFERWALL'">
                                                        충전소 {{ getOfferwallTagsArray(item).length }}개:
                                                        {{ getOfferwallTagsArray(item).join(', ') || '(미선택)' }}
                                                    </template>
                                                    <template v-else>
                                                        <div>
                                                            플레이스먼트 키: {{ item.placement_key || '-' }}
                                                            <span class="ml-2 text-caption">노출제한: {{ (typeof item.limit_count === 'number' ? item.limit_count : -1) === -1 ? '∞ (무제한)' : item.limit_count }}</span>
                                                        </div>
                                                        <div v-if="item.description" class="text-caption">{{ item.description }}</div>
                                                    </template>
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action class="d-flex flex-row align-center" style="min-width: 100px;">
                                                <v-btn icon small color="primary" @click="editChargeTab(index)" title="수정">
                                                    <v-icon>mdi-pencil</v-icon>
                                                </v-btn>
                                                <v-btn icon small color="red" @click="deleteChargeTab(index)" title="삭제">
                                                    <v-icon>mdi-delete</v-icon>
                                                </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </draggable>

                                    <v-container v-if="charge_tab_list.length === 0" class="text-center py-8">
                                        <v-icon large color="grey lighten-1" class="mb-3">mdi-information-outline</v-icon>
                                        <p class="text-body-2 grey--text">등록된 탭이 없습니다. 우측 상단의 "탭 추가" 버튼을 눌러 등록하세요.</p>
                                    </v-container>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-divider class="my-1"/>
                    </v-list>

                    <!-- 황금동상 오퍼월 관리 (GOLDEN_STATUE_OFFERWALL_LIST) -->
                    <v-list class="pa-0">
                        <v-list-item class="section-header" style="background:#FFF8E1; min-height: 48px;">
                            <v-list-item-content>
                                <v-list-item-title class="text-h6 font-weight-bold">[ 황금동상 오퍼월 관리 ]</v-list-item-title>
                                <v-list-item-subtitle class="text-caption grey--text">
                                    "충전소 관리"에 등록된 오퍼월을 읽어와, 황금동상에 노출할 오퍼월을 추가/삭제합니다. (GOLDEN_STATUE_OFFERWALL_LIST)
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>
                        <v-list-item class="px-4 py-3">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-list-item
                                        v-for="(o, gIndex) in goldenStatueOfferwalls"
                                        :key="'golden-ofw-' + gIndex"
                                        class="mb-2"
                                        style="border: 1px solid #e0e0e0; border-radius: 6px;"
                                    >
                                        <v-avatar size="40" class="mr-3" tile>
                                            <img
                                                v-if="o.icon"
                                                :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + o.icon"
                                                alt="icon"
                                                style="object-fit: cover; border: 1px solid #ddd; border-radius: 4px;"
                                            />
                                            <v-icon v-else size="28" color="grey lighten-1">mdi-image-off-outline</v-icon>
                                        </v-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <span class="font-weight-bold">{{ o.name }}</span>
                                                <v-chip v-if="o.missing" x-small color="red lighten-4" text-color="red darken-2" class="ml-2">삭제된 충전소</v-chip>
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="grey--text text-caption">태그: {{ o.tag }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-btn icon small color="red" @click="removeGoldenStatueOfferwall(gIndex)" title="삭제">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>

                                    <v-container v-if="golden_statue_offerwall_list.length === 0" class="text-center py-4 grey--text text-caption">
                                        추가된 황금동상 오퍼월이 없습니다. 아래에서 추가해주세요.
                                    </v-container>

                                    <v-select
                                        class="mt-2"
                                        label="황금동상 오퍼월 추가"
                                        :items="goldenStatueAvailableOptions"
                                        item-text="label"
                                        item-value="value"
                                        v-model="addGoldenStatueTagSelector"
                                        outlined
                                        dense
                                        hide-details
                                        clearable
                                        no-data-text="추가할 오퍼월이 없습니다. 충전소 관리 탭에서 등록해주세요."
                                        @change="addGoldenStatueOfferwall"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-divider class="my-1"/>
                    </v-list>
                </v-tab-item>

                <!-- ===== 탭 7: 디버깅 ===== -->
                <v-tab-item>
                    <v-list class="pa-0" flat>
                        <v-list-item class="section-header" style="background:#FFF3E0; min-height: 48px;">
                            <v-list-item-content>
                                <v-list-item-title class="text-h6 font-weight-bold">[ 디버그 유저 리스트 ]</v-list-item-title>
                                <v-list-item-subtitle class="text-caption grey--text">
                                    디버깅 대상 유저 아이디를 등록/삭제하여 관리합니다
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>

                        <v-list-item class="px-4 py-3">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-row class="align-center mb-2" no-gutters>
                                        <v-col cols="12" md="6" class="pa-1">
                                            <v-text-field
                                                label="유저 아이디 입력"
                                                placeholder="예: user123"
                                                v-model="newDebugUserId"
                                                outlined
                                                dense
                                                hide-details
                                                @keyup.enter="addDebugUserId"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="2" class="pa-1">
                                            <v-btn
                                                color="primary"
                                                small
                                                @click="addDebugUserId"
                                                :disabled="!newDebugUserId || !newDebugUserId.trim()"
                                            >
                                                <v-icon left small>mdi-plus</v-icon>추가
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <div class="d-flex flex-wrap gap-1 mt-1">
                                        <v-chip
                                            v-for="(uid, idx) in debugUserIds"
                                            :key="idx"
                                            close
                                            color="orange"
                                            text-color="white"
                                            class="ma-1"
                                            @click:close="removeDebugUserId(idx)"
                                        >
                                            {{ uid }}
                                        </v-chip>
                                        <span v-if="debugUserIds.length === 0" class="grey--text text-caption pa-2">
                                            등록된 디버그 유저가 없습니다.
                                        </span>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-divider class="my-1"/>

                        <!-- 클라이언트 로그 -->
                        <v-list-item class="section-header" style="background:#FFEBEE; min-height: 48px;">
                            <v-list-item-content>
                                <v-list-item-title class="text-h6 font-weight-bold">[ 클라이언트 로그 ]</v-list-item-title>
                                <v-list-item-subtitle class="text-caption grey--text">
                                    PUBLIC_CLIENT_LOG 테이블의 최근 로그를 조회합니다
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider/>

                        <v-list-item class="px-4 py-3">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <!-- 검색 영역 -->
                                    <v-row class="align-center mb-3" no-gutters>
                                        <v-col cols="12" md="5" class="pa-1">
                                            <v-text-field
                                                label="유저 아이디로 검색"
                                                placeholder="USER_ID 입력 (비우면 전체 최근 로그)"
                                                v-model="logSearchUserId"
                                                outlined
                                                dense
                                                hide-details
                                                clearable
                                                @keyup.enter="fetchClientLogs"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="2" class="pa-1">
                                            <v-text-field
                                                label="조회 수"
                                                v-model.number="logFetchCount"
                                                outlined
                                                dense
                                                hide-details
                                                type="number"
                                                min="1"
                                                max="500"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="2" class="pa-1">
                                            <v-btn
                                                color="deep-orange"
                                                dark
                                                small
                                                @click="fetchClientLogs"
                                                :loading="loadingClientLogs"
                                            >
                                                <v-icon left small>mdi-magnify</v-icon>조회
                                            </v-btn>
                                        </v-col>
                                    </v-row>

                                    <!-- 로그 테이블 -->
                                    <v-data-table
                                        :headers="clientLogHeaders"
                                        :items="clientLogs"
                                        :loading="loadingClientLogs"
                                        :footer-props="{'items-per-page-options':[20, 50, 100]}"
                                        dense
                                        class="elevation-1"
                                    >
                                        <template v-slot:item="{ item }">
                                            <tr>
                                                <td class="text-caption">{{ item.PID }}</td>
                                                <td class="text-caption">{{ item.USER_ID }}</td>
                                                <td class="text-caption" style="max-width:400px;">
                                                    {{ item.LOG_TEXT && item.LOG_TEXT.length > 50 ? item.LOG_TEXT.substring(0, 50) + '...' : item.LOG_TEXT }}
                                                </td>
                                                <td class="text-caption">{{ item.CREATE_DT }}</td>
                                                <td>
                                                    <v-btn x-small color="deep-orange" dark @click="openLogDetail(item)">
                                                        <v-icon left x-small>mdi-eye</v-icon>자세히
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-slot:no-data>
                                            <span class="grey--text">조회된 로그가 없습니다. 조회 버튼을 눌러주세요.</span>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-divider class="my-1"/>
                    </v-list>
                </v-tab-item>

                <!-- 8번 탭: 광고관리 -->
                <v-tab-item>
                    <v-container fluid>
                        <!-- 전면광고 관리 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold indigo lighten-5">
                                <v-icon left size="18" color="indigo">mdi-bullhorn</v-icon>
                                전면광고 관리
                                <span class="text-caption grey--text ml-2">플레이스먼트별 전면광고 타입 설정</span>
                            </v-card-subtitle>
                            <v-card-text class="pa-0">
                                <template v-for="(p, i) in interstitial_placements">
                                    <v-divider v-if="i > 0" :key="p.key + '_div'"></v-divider>
                                    <div :key="p.key" class="d-flex align-center flex-wrap px-4 py-3">
                                        <div class="flex-grow-1 mr-4" style="min-width: 200px;">
                                            <div class="text-subtitle-2 font-weight-bold">{{ p.label }}</div>
                                            <div class="text-caption grey--text mt-1">{{ p.desc }}</div>
                                        </div>
                                        <div style="width: 240px;">
                                            <v-select
                                                v-model="ad_placement_values[p.key]"
                                                :items="interstitial_ad_type_options"
                                                item-text="text"
                                                item-value="value"
                                                placeholder="광고 타입 선택"
                                                outlined
                                                dense
                                                hide-details
                                                clearable
                                            ></v-select>
                                        </div>
                                    </div>
                                </template>
                            </v-card-text>
                        </v-card>

                        <!-- 저장 버튼 -->
                        <v-card outlined>
                            <v-card-text class="pa-3 text-center">
                                <v-btn color="lime accent-3" width="150px" @click="OnSaveDone">
                                    <v-icon left>mdi-content-save</v-icon>
                                    전체 저장
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-tab-item>
            </v-tabs-items>

            <!-- 충전소 등록/수정 다이얼로그 -->
            <v-dialog v-model="offerwallDialog" max-width="720px" :fullscreen="$vuetify.breakpoint.xsOnly">
                <v-card>
                    <v-card-title>
                        <v-icon left color="primary">mdi-power-plug</v-icon>
                        <span class="headline">{{ editingOfferwallIndex >= 0 ? '충전소 수정' : '충전소 등록' }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row dense align="center">
                                <v-col cols="12" md="4" class="text-center">
                                    <div class="text-caption mb-1">아이콘 (128x128 권장)</div>
                                    <img
                                        v-if="editingOfferwall.icon"
                                        :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + editingOfferwall.icon"
                                        alt="아이콘"
                                        style="width: 80px; height: 80px; border: 2px solid #ddd; border-radius: 8px; object-fit: cover;"
                                    />
                                    <v-icon v-else size="80" color="grey lighten-1">mdi-image-off-outline</v-icon>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <v-file-input
                                        label="아이콘 업로드"
                                        accept="image/*"
                                        v-model="editingOfferwall.iconFile"
                                        prepend-icon="mdi-image"
                                        outlined
                                        dense
                                        hide-details
                                        show-size
                                    ></v-file-input>
                                    <div class="text-caption grey--text mt-1">선택 후 저장 시 S3에 업로드됩니다.</div>
                                </v-col>
                            </v-row>
                            <v-row dense class="mt-3">
                                <v-col cols="12">
                                    <v-text-field
                                        label="충전소 이름 *"
                                        v-model="editingOfferwall.name"
                                        outlined
                                        dense
                                        hide-details
                                        placeholder="예: TNK 오퍼월"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" class="mt-2">
                                    <v-text-field
                                        label="태그 / 플레이스먼트 키"
                                        v-model="editingOfferwall.tag"
                                        outlined
                                        dense
                                        hide-details
                                        placeholder="예: tnk_main"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="mt-2">
                                    <v-select
                                        label="활성화 여부"
                                        v-model="editingOfferwall.is_active"
                                        :items="[{text: '활성화', value: 'Y'}, {text: '비활성화', value: 'N'}]"
                                        outlined
                                        dense
                                        hide-details
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md="6" class="mt-2">
                                    <v-select
                                        label="이벤트 모드"
                                        v-model="editingOfferwall.is_event_mode"
                                        :items="[{text: '이벤트 모드 ON', value: 'Y'}, {text: '일반 (OFF)', value: 'N'}]"
                                        outlined
                                        dense
                                        hide-details
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" class="mt-2" v-if="editingOfferwall.is_event_mode === 'Y' || editingOfferwall.event_start || editingOfferwall.event_end">
                                    <div class="text-caption mb-1 pink--text text--darken-2">
                                        <v-icon x-small color="pink darken-2">mdi-calendar-clock</v-icon>
                                        이벤트 기간 — 시작·종료를 모두 지정해야 이벤트가 켜집니다 (미설정/기간 밖이면 OFF)
                                    </div>
                                    <div v-if="editingOfferwall.is_event_mode !== 'Y' && (editingOfferwall.event_start || editingOfferwall.event_end)" class="text-caption mb-1 grey--text">
                                        이벤트 모드가 OFF라 지금은 적용되지 않지만, 입력한 기간은 그대로 보존됩니다.
                                    </div>
                                    <div class="text-caption grey--text mb-1">시작</div>
                                    <v-row dense align="center" class="mb-1">
                                        <v-col cols="12" sm="6">
                                            <v-menu v-model="startMenuOfw" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        :value="ofwStartDate"
                                                        label="날짜"
                                                        placeholder="미설정"
                                                        readonly
                                                        clearable
                                                        @click:clear="clearOfwEvent('event_start')"
                                                        prepend-inner-icon="mdi-calendar"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="ofwStartDate" locale="ko" no-title @input="startMenuOfw = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="6" sm="3">
                                            <v-select v-model="ofwStartHour" :items="hourItems" label="시" dense outlined hide-details :disabled="!ofwStartDate"></v-select>
                                        </v-col>
                                        <v-col cols="6" sm="3">
                                            <v-select v-model="ofwStartMin" :items="minuteItems" label="분" dense outlined hide-details :disabled="!ofwStartDate"></v-select>
                                        </v-col>
                                    </v-row>
                                    <div class="text-caption grey--text mb-1">종료</div>
                                    <v-row dense align="center">
                                        <v-col cols="12" sm="6">
                                            <v-menu v-model="endMenuOfw" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        :value="ofwEndDate"
                                                        label="날짜"
                                                        placeholder="미설정"
                                                        readonly
                                                        clearable
                                                        @click:clear="clearOfwEvent('event_end')"
                                                        prepend-inner-icon="mdi-calendar"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="ofwEndDate" locale="ko" no-title @input="endMenuOfw = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="6" sm="3">
                                            <v-select v-model="ofwEndHour" :items="hourItems" label="시" dense outlined hide-details :disabled="!ofwEndDate"></v-select>
                                        </v-col>
                                        <v-col cols="6" sm="3">
                                            <v-select v-model="ofwEndMin" :items="minuteItems" label="분" dense outlined hide-details :disabled="!ofwEndDate"></v-select>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="grey" text @click="closeOfferwallDialog">취소</v-btn>
                        <v-btn color="primary" :loading="savingOfferwall" @click="saveOfferwall">저장</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- 충전소 탭 등록/수정 다이얼로그 -->
            <v-dialog v-model="chargeTabDialog" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly">
                <v-card>
                    <v-card-title>
                        <v-icon left color="primary">mdi-tab</v-icon>
                        <span class="headline">{{ editingChargeTabIndex >= 0 ? '충전소 탭 수정' : '충전소 탭 등록' }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row dense>
                                <v-col cols="12">
                                    <v-select
                                        label="탭 타입 *"
                                        v-model="editingChargeTab.type"
                                        :items="chargeTabTypeOptions"
                                        item-text="text"
                                        item-value="value"
                                        outlined
                                        dense
                                        hide-details
                                        :disabled="editingChargeTabIndex >= 0"
                                    ></v-select>
                                </v-col>
                            </v-row>

                            <!-- PLACEMENT_BIG / PLACEMENT_NORMAL 공통 필드 -->
                            <template v-if="editingChargeTab.type === 'PLACEMENT_BIG' || editingChargeTab.type === 'PLACEMENT_NORMAL'">
                                <v-row dense class="mt-3">
                                    <v-col cols="12">
                                        <v-text-field
                                            label="이름 *"
                                            v-model="editingChargeTab.name"
                                            outlined
                                            dense
                                            hide-details
                                            placeholder="예: 추천 충전소"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="mt-2">
                                        <v-textarea
                                            label="설명"
                                            v-model="editingChargeTab.description"
                                            outlined
                                            dense
                                            hide-details
                                            rows="2"
                                            auto-grow
                                            placeholder="예: 한 번에 큰 보상을 받을 수 있는 추천 충전소"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" class="mt-2">
                                        <v-text-field
                                            label="플레이스먼트 키 *"
                                            v-model="editingChargeTab.placement_key"
                                            outlined
                                            dense
                                            hide-details
                                            placeholder="예: charge_main_top"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="mt-2">
                                        <v-text-field
                                            label="노출 개수 제한 (limit_count)"
                                            v-model.number="editingChargeTab.limit_count"
                                            type="number"
                                            outlined
                                            dense
                                            hide-details
                                            placeholder="-1"
                                            persistent-hint
                                            hint="-1 이면 제한 없음. 양수면 그 개수만큼만 노출."
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </template>

                            <!-- OFFERWALL: 충전소 관리 리스트에서 다중 선택 + 정렬 + 삭제 -->
                            <template v-else-if="editingChargeTab.type === 'OFFERWALL'">
                                <v-row dense class="mt-3">
                                    <v-col cols="12">
                                        <div class="text-subtitle-2 mb-2">
                                            <v-icon left small>mdi-format-list-bulleted</v-icon>
                                            선택된 충전소 ({{ editingChargeTab.offerwall_tags.length }}개) — 드래그로 순서 변경
                                        </div>
                                        <draggable
                                            v-model="editingChargeTab.offerwall_tags"
                                            handle=".drag-mini"
                                            @end="onOfferwallTagsDragEnd"
                                        >
                                            <v-list-item
                                                v-for="(tag, i) in editingChargeTab.offerwall_tags"
                                                :key="'sel-' + tag"
                                                style="background-color: #FFF8E1; border: 1px solid #FFE0B2; border-radius: 4px; min-height: 48px;"
                                                class="mb-1"
                                            >
                                                <v-icon class="drag-mini mr-2" small color="brown darken-1">mdi-drag</v-icon>
                                                <v-avatar size="28" class="mr-2" tile>
                                                    <img
                                                        v-if="resolveOfferwallByTag(tag) && resolveOfferwallByTag(tag).icon"
                                                        :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + resolveOfferwallByTag(tag).icon"
                                                        alt="icon"
                                                        style="object-fit: cover; border-radius: 4px;"
                                                    />
                                                    <v-icon v-else size="20" color="grey lighten-1">mdi-image-off-outline</v-icon>
                                                </v-avatar>
                                                <v-list-item-content class="py-1">
                                                    <v-list-item-title class="text-body-2">
                                                        {{ resolveOfferwallByTag(tag) ? (resolveOfferwallByTag(tag).name || '(이름 없음)') : '(미연결)' }}
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle class="text-caption">tag: {{ tag }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-btn icon small color="red" @click="removeOfferwallFromTab(i)" title="삭제">
                                                    <v-icon small>mdi-close</v-icon>
                                                </v-btn>
                                            </v-list-item>
                                        </draggable>
                                        <v-container v-if="editingChargeTab.offerwall_tags.length === 0" class="text-center py-3 grey--text text-caption">
                                            선택된 충전소가 없습니다. 아래에서 추가해주세요.
                                        </v-container>
                                    </v-col>
                                    <v-col cols="12" class="mt-2">
                                        <v-select
                                            label="충전소 추가"
                                            :items="availableOfferwallOptions"
                                            item-text="label"
                                            item-value="value"
                                            v-model="addOfferwallTagSelector"
                                            outlined
                                            dense
                                            hide-details
                                            clearable
                                            no-data-text="추가할 충전소가 없습니다. 충전소 관리 탭에서 등록해주세요."
                                            @change="addOfferwallToTab"
                                        ></v-select>
                                        <div class="text-caption grey--text mt-1">
                                            * "충전소 관리" 탭에 등록된 항목 중 태그가 있는 항목만 추가 가능. 중복 추가 불가.
                                        </div>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="grey" text @click="closeChargeTabDialog">취소</v-btn>
                        <v-btn color="primary" :loading="savingChargeTab" @click="saveChargeTab">저장</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- 저장 버튼 (공통) -->
            <v-list class="pa-0">
                <v-list-item class="px-4 py-4" style="background:#F5F5F5;">
                    <v-spacer></v-spacer>
                    <v-btn
                        width="150px"
                        color="success"
                        large
                        elevation="2"
                        @click="OnSaveDone"
                        :loading="loadingData"
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        저장
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-list-item>
            </v-list>
        </v-card>

        <!-- 서버 재시작 (라이브만 노출) -->
        <div v-if="isLive" class="text-center my-6">
            <v-btn color="red" dark large elevation="2" @click="onRestartServer">
                <v-icon left>mdi-restart</v-icon>
                서버 재시작
            </v-btn>
        </div>

        <v-card class="mx-auto mt-4" max-width="95%" elevation="2" v-if="is_using_table">
            <v-toolbar color="#37474F" dark class="flex-wrap">
                <v-toolbar-title>테이블 관리</v-toolbar-title>
            </v-toolbar>
            <v-list>
                <v-list-item style="background:#CFD8DC" class="flex-wrap">
                    <span style="min-width:200px">
                        <v-card-title class="font-weight-bold">테이블 업로드</v-card-title>
                    </span>
                    <span>
                        <v-file-input
                            v-model="table_file"
                            placeholder="Upload your documents"
                            label="File input"
                            multiple="multiple"
                            prepend-icon="mdi-paperclip"/>
                    </span>
                    <div class="px-3"></div>
                    <span>
                        <v-text-field label="템플릿 버전" v-model="table_file_version" value=""></v-text-field>
                    </span>
                    <v-spacer/>
                    <span>
                        <v-btn width="120px" color="lime accent-3" @click="OnSaveDone">UPLOAD</v-btn>
                    </span>
                </v-list-item>

                <div style="overflow-x: auto;">
                <v-data-table
                    :footer-props="{'items-per-page-options':[30, -1]}"
                    :headers="headers"
                    :items="table_list_history"
                    :loading="loadingData">
                    <template v-slot:item="row">
                        <tr>
                            <td>{{row.item.version}}</td>
                            <td>{{row.item.admin}}</td>
                            <td>{{row.item.update_date}}</td>
                        </tr>
                    </template>
                </v-data-table>
                </div>
            </v-list>
        </v-card>
    <div class="py-12"></div>
    <div class="py-12"></div>

        <!-- 로그 상세보기 다이얼로그 -->
        <v-dialog
            v-model="dialogLogDetail"
            max-width="800px"
            @keydown.esc="dialogLogDetail = false"
            tabindex="0"
        >
            <v-card>
                <v-toolbar color="deep-orange" dark dense flat>
                    <v-toolbar-title>로그 상세보기</v-toolbar-title>
                    <v-spacer/>
                    <v-btn icon @click="dialogLogDetail = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-4" v-if="selectedLog">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <td class="font-weight-bold" style="width:120px">PID</td>
                                <td>{{ selectedLog.PID }}</td>
                            </tr>
                            <tr>
                                <td class="font-weight-bold">USER_ID</td>
                                <td>{{ selectedLog.USER_ID }}</td>
                            </tr>
                            <tr>
                                <td class="font-weight-bold">일시</td>
                                <td>{{ selectedLog.CREATE_DT }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <v-divider class="my-3"/>
                    <div class="text-subtitle-2 font-weight-bold mb-1">LOG_TEXT</div>
                    <v-sheet
                        class="pa-3"
                        color="grey lighten-4"
                        rounded
                        style="white-space:pre-wrap; word-break:break-all; max-height:400px; overflow-y:auto; font-family:monospace; font-size:13px;"
                    >{{ selectedLog.LOG_TEXT }}</v-sheet>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn text @click="dialogLogDetail = false">닫기 (ESC)</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import axios from 'axios'; // 먼저 axios import 필요
    import {mapActions} from 'vuex';
    import moment from 'moment'
    import store from '../../store';
    import config from '../../config/config';
    import {format, parseISO} from 'date-fns'
import { divide } from 'lodash';
    import draggable from 'vuedraggable';
    const { s3_upload ,  FileUpload_Async, FileUpload_JSON } = require("../../util/fileutil");
    
    export default {
        name: 'UserList',

        data: () => ({
            serverTime:'0000-00-00 00:00:00',
            date:moment().format('yyyy-MM-DD'),
            loadingData: false,
            package_name:'io.snapplay.cpu',
            gameName:'금나르기',       
            is_using_table: false,
            baseUrl:'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/carrygold/manage/live/ServerState.json',
            
            // 필드 데이터 저장소 (자동 초기화됨)
            fieldData: {},

            // 탭: 0 일반설정, 1 이벤트설정, 2 환율설정
            activeTab: 0,

            // 탭 정의 (PC는 v-tabs, 모바일은 v-select 로 동일 데이터 사용)
            tabItems: [
                { value: 0, text: '일반설정',      icon: 'mdi-cog' },
                { value: 1, text: '이벤트설정',    icon: 'mdi-star' },
                { value: 2, text: '환율설정',      icon: 'mdi-currency-usd' },
                { value: 3, text: '데이터 관리',   icon: 'mdi-database' },
                { value: 4, text: '충전소 관리',   icon: 'mdi-power-plug' },
                { value: 5, text: '충전소 탭 관리', icon: 'mdi-tab' },
                { value: 6, text: '디버깅',        icon: 'mdi-bug' },
                { value: 7, text: '광고관리',      icon: 'mdi-bullhorn' },
            ],

            // 전면광고 관리 — 플레이스먼트별 광고 타입 (아래 key 를 그대로 INTERSTITIAL_AD_PLACEMENTS 에 저장)
            interstitial_placements: [
                { key: 'CUP_EVENT',        label: 'CUP_EVENT',        desc: '컵 이벤트' },
                { key: 'FRIEND_GATHER_AI', label: 'FRIEND_GATHER_AI', desc: 'AI 친구골드 저장하기' },
                { key: 'FRIEND_GATHER',    label: 'FRIEND_GATHER',    desc: '친구골드 저장하기' },
                { key: 'WALLET_SAVE',      label: 'WALLET_SAVE',      desc: '지갑 저장' },
                { key: 'OX_SUBMIT',        label: 'OX_SUBMIT',        desc: 'OX 선택지 고름' },
                { key: 'OX_WRONG',         label: 'OX_WRONG',         desc: 'OX 틀렸을 때' },
                { key: 'TOKEN_ATTENDANCE', label: 'TOKEN_ATTENDANCE', desc: '토큰 출석체크' },
                { key: 'TOKEN_SAVE',       label: 'TOKEN_SAVE',       desc: '토큰 저장하기' },
            ],
            interstitial_ad_type_options: [
                { text: '전면Short (ADMOB_SHORT)', value: 'ADMOB_SHORT' },
                { text: '전면Long (ADMOB_LONG)',   value: 'ADMOB_LONG' },
                { text: 'ADX 전면 (ADX_INTER)',    value: 'ADX_INTER' },
                { text: '광고 스킵 (OFF)',          value: 'OFF' },
            ],
            ad_placement_values: {
                CUP_EVENT: '',
                FRIEND_GATHER_AI: '',
                FRIEND_GATHER: '',
                WALLET_SAVE: '',
                OX_SUBMIT: '',
                OX_WRONG: '',
                TOKEN_ATTENDANCE: '',
                TOKEN_SAVE: '',
            },

            // 필드 설정: 여기에만 정의하면 자동으로 UI 생성, 로드/저장 처리됨
            fieldConfig: [
                {
                    tab: 'general',
                    title: '[서버 관리]',
                    groups: [
                        {
                            fields: [
                                {
                                    jsonKey: 'NAME',
                                    label: '게임이름',
                                    type: 'text',
                                    default: '금나르기',
                                    cols: 12
                                }
                            ]
                        },
                        {
                            title: '최신버전',
                            fields: [
                                {
                                    jsonKey: 'VERSION_AOS',
                                    label: 'AOS',
                                    type: 'text',
                                    placeholder: 'APK version',
                                    default: '',
                                    cols: 5
                                },
                                {
                                    jsonKey: 'VERSION_IOS',
                                    label: 'IOS',
                                    type: 'text',
                                    placeholder: 'IPA Version',
                                    default: '',
                                    cols: 5
                                }
                            ]
                        },
                        {
                            title: '최소(강제업뎃)',
                            fields: [
                                {
                                    jsonKey: 'VERSION_AOS_MIN',
                                    isMinVersion: true,
                                    label: 'AOS',
                                    type: 'text',
                                    placeholder: 'APK version',
                                    default: '',
                                    cols: 5
                                },
                                {
                                    jsonKey: 'VERSION_IOS_MIN',
                                    isMinVersion: true,
                                    label: 'IOS',
                                    type: 'text',
                                    placeholder: 'IPA Version',
                                    default: '',
                                    cols: 5
                                }
                            ]
                        },
                        {
                            title: '검수버전',
                            fields: [
                                {
                                    jsonKey: 'CHECK_VERSION_AOS',
                                    label: 'AOS',
                                    type: 'text',
                                    placeholder: '검수중인 버전이 없는경우 비워두세요.',
                                    default: '',
                                    cols: 5,
                                    isCheckVersion: true
                                },
                                {
                                    jsonKey: 'CHECK_VERSION_IOS',
                                    label: 'IOS',
                                    type: 'text',
                                    placeholder: '검수중인 버전이 없는경우 비워두세요.',
                                    default: '',
                                    cols: 5,
                                    isCheckVersion: true
                                }
                            ]
                        }
                    ]
                },
                {
                    tab: 'general',
                    title: '[ 서버 점검 상태 ]',
                    groups: [
                        {
                            fields: [
                                {
                                    jsonKey: 'SERVER_STATE_AOS',
                                    label: 'AOS서버상태',
                                    type: 'select',
                                    options: 'serverStateInfoList',
                                    default: '1',
                                    cols: 6
                                },
                                {
                                    jsonKey: 'SERVER_STATE_IOS',
                                    label: 'IOS서버상태',
                                    type: 'select',
                                    options: 'serverStateInfoList',
                                    default: '1',
                                    cols: 6
                                }
                            ]
                        }
                    ]
                },
                {
                    tab: 'general',
                    title: '[ 설정 ]',
                    groups: [
                        {
                            fields: [
                                {
                                    jsonKey: 'ACTIVATION_EVENT_REVIEW',
                                    label: '리뷰이벤트',
                                    type: 'select',
                                    options: 'serverStateEventInfo',
                                    default: 'N',
                                    cols: 6
                                }
                            ]
                        },
                        {
                            fields: [
                                {
                                    jsonKey: 'SHOP_PRODUCT_TYPE',
                                    label: '(구)교환소',
                                    type: 'text',
                                    default: '',
                                    disabled: true,
                                    cols: 6
                                },
                                {
                                    jsonKey: 'SHOP_PRODUCT_TYPE_REVIEW',
                                    label: '(구)교환소(리뷰전용)',
                                    type: 'text',
                                    default: '',
                                    disabled: true,
                                    cols: 6
                                },
                                {
                                    jsonKey: 'PNJ_COUPON_SHOP_TYPE',
                                    label: '(PNJ)쿠폰교환소',
                                    type: 'text',
                                    placeholder: '예: main_shop',
                                    default: '',
                                    cols: 6
                                },
                                {
                                    jsonKey: 'PNJ_COUPON_SHOP_TYPE_REVIEW',
                                    label: '(PNJ)쿠폰교환소 검수전용',
                                    type: 'text',
                                    default: '',
                                    cols: 6
                                }
                            ]
                        },
                        {
                            fields: [
                                {
                                    jsonKey: 'OFFERWALL_RECOMMAND_KEY',
                                    label: '강화소 추천 키',
                                    type: 'text',
                                    default: 'cpu_영자추천2',
                                    cols: 6
                                },
                                {
                                    jsonKey: 'OFFERWALL_RECOMMAND_KEY_CHECK',
                                    label: '강화소 추천 키 (검수버전)',
                                    type: 'text',
                                    placeholder: '검수중인 버전용 키',
                                    default: '',
                                    cols: 6,
                                    isCheckVersion: true
                                }
                            ]
                        },
                        {
                            fields: [
                                {
                                    jsonKey: 'COUPANG_BANNER_LINK',
                                    label: '쿠팡배너 링크',
                                    type: 'text',
                                    placeholder: '쿠팡 배너 URL을 입력하세요',
                                    default: '',
                                    cols: 12
                                }
                            ]
                        },
                        {
                            fields: [
                                {
                                    jsonKey: 'HOME_API_PLACEMENT',
                                    label: '홈 API키',
                                    type: 'text',
                                    placeholder: '홈 API 플레이스먼트 키를 입력하세요',
                                    default: '',
                                    cols: 12
                                }
                            ]
                        },
                        {
                            fields: [
                                {
                                    jsonKey: 'MULTIPLE_PLACEMENT',
                                    label: '멀티게임항목',
                                    type: 'text',
                                    placeholder: '멀티게임 플레이스먼트 키를 입력하세요',
                                    default: '',
                                    cols: 12
                                }
                            ]
                        },
                        {
                            fields: [
                                {
                                    jsonKey: 'PHONE_VERIFY_EMAIL',
                                    label: '전화번호 인증 이메일',
                                    type: 'text',
                                    placeholder: '예: verify@pnjstudio.com',
                                    default: '',
                                    cols: 12
                                }
                            ]
                        },
                        {
                            fields: [
                                {
                                    jsonKey: 'INQUIRY_EMAIL',
                                    label: '문의사항 이메일',
                                    type: 'text',
                                    placeholder: '예: help@pnjstudio.com',
                                    default: '',
                                    cols: 12
                                }
                            ]
                        }
                    ]
                },
                {
                    tab: 'general',
                    title: '[ S3 / 네트워크 ]',
                    groups: [
                        {
                            fields: [
                                {
                                    jsonKey: 'S3_BASE_PATH',
                                    label: 'S3 BasePath',
                                    type: 'text',
                                    placeholder: '예: https://content-filecenter.s3.ap-northeast-2.amazonaws.com/',
                                    default: '',
                                    cols: 12
                                }
                            ]
                        },
                        {
                            fields: [
                                {
                                    jsonKey: 'S3_CLOUD_PATH',
                                    label: 'S3 CloudPath',
                                    type: 'text',
                                    placeholder: '예: https://cdn.pnjstudio.com/',
                                    default: '',
                                    cols: 12
                                }
                            ]
                        },
                        {
                            fields: [
                                {
                                    jsonKey: 'WEBSOCKET_URL',
                                    label: '웹소켓 주소',
                                    type: 'text',
                                    placeholder: '예: wss://ws.pnjstudio.com',
                                    default: '',
                                    cols: 12
                                }
                            ]
                        }
                    ]
                },
                {
                    tab: 'event',
                    title: '[ 리뷰이벤트 링크 설정 ]',
                    groups: [
                        {
                            fields: [
                                {
                                    jsonKey: 'REVIEW_EVENT_LINK_AOS',
                                    label: 'AOS',
                                    type: 'text',
                                    placeholder: '리뷰이벤트 링크',
                                    default: '',
                                    cols: 6
                                },
                                {
                                    jsonKey: 'REVIEW_EVENT_LINK_IOS',
                                    label: 'IOS',
                                    type: 'text',
                                    placeholder: '리뷰이벤트 링크',
                                    default: '',
                                    cols: 6
                                }
                            ]
                        }
                    ]
                },
                {
                    tab: 'exchange',
                    title: '[ 환율설정 ]',
                    groups: [
                        {
                            fields: [
                                {
                                    jsonKey: 'EXCHANGE_RATE_NORMAL',
                                    label: '일반상품 *',
                                    type: 'text',
                                    placeholder: '일반상품 환율',
                                    default: '',
                                    cols: 6
                                },
                                {
                                    jsonKey: 'EXCHANGE_RATE_GOLD',
                                    label: '골드상품 *',
                                    type: 'text',
                                    placeholder: '골드상품 환율',
                                    default: '',
                                    cols: 6
                                },
                                {
                                    jsonKey: 'EXCHANGE_REWARD_NORMAL_PERCENT',
                                    label: '일반상품 환급보상 (%)',
                                    type: 'text',
                                    placeholder: '% 타입 환급보상',
                                    default: '',
                                    cols: 6
                                },
                                {
                                    jsonKey: 'EXCHANGE_REWARD_GOLD_PER_GRAM',
                                    label: '1g당 금교환 보상 (절대값)',
                                    type: 'text',
                                    placeholder: '1g당 환급 보상값',
                                    default: '',
                                    cols: 6
                                }
                            ]
                        }
                    ]
                }
            ],

            // 옵션 리스트 (select 필드에서 사용)
            serverStateInfoList: [
                { name: '정상 작동中', value: '1' },
                { name: '서버 점검中', value: '2' }
            ],
            serverStateEventInfo: [
                { name: '활성화', value: 'Y' },
                { name: '비활성화', value: 'N' }
            ],
            event_offerwall_guide_grade: [
                { name: '초급', value: '1' },
                { name: '중급', value: '2' },
                { name: '고급', value: '3' }
            ],
            event_offerwall_guide_reward: [
                { name: '보통', value: '1' },
                { name: '많음', value: '2' },
                { name: '엄청많음', value: '3' }
            ],

            // 특수 필드 (자동 생성되지 않는 필드)
            event_offerwall_guide_list: [{ placement: '', grade: '', reward: '' }],
            event_offerwall_guide_list_count: 1,
            // 빈 배열로 시작 — 추가 버튼 눌렀을 때만 항목이 들어가도록 (저장만 눌러도 빈 항목이 생기는 버그 방지)
            event_thumb_list: [],
            // 스탬프 이벤트 토글 — 서버에 'Y'/'N' 으로 저장
            enable_stamp_event_tyr: 'N',
            enable_stamp_event_maf: 'N',
            daily_offerwall_challenge_count: 8,   // 일일 오퍼월 챌린지 카운트 설정 (DAILY_OFFERWALL_CHALLENGE_COUNT)
            eventThumbTypeOptions: [
                { name: '링크 (LINK)',                value: 'link' },
                { name: '플레이스먼트 (PLACEMENT)',     value: 'placement' },
                { name: '캠페인 (CAMPAIGN)',           value: 'campaign' },
                { name: '오퍼월 (OFFERWALL)',          value: 'offerwall' }
            ],
            eventLocationOptions: [
                { name: '메인', value: 'main' },
                { name: '운영자공지', value: 'admin_notice' }
            ],
            eventThumbDialog: false,
            eventThumbEditIndex: -1,
            eventThumbDialogData: {
                title: '',
                desc: '',
                location: 'main',
                thumb: '',
                type: 'link',
                param: '',
                sub_param: ''
            },
            eventThumbDialogTempFile: null,
            table_file: [],
            table_file_version: "1.0.0",
            headers: [],
            table_list_history: [],

            // 데이터 관리 - 부스터 퀘스트
            boosterQuestFile: null,
            enableUpload_BoosterQuest: false,
            loadingBoosterQuest: false,

            // 데이터 관리 - 부스터 퀘스트 V2 (신규 포맷, 별도 파일)
            boosterQuestFileV2: null,
            enableUpload_BoosterQuestV2: false,
            loadingBoosterQuestV2: false,

            // 데이터 관리 - 부스터 퀘스트 오퍼월 타입
            boosterQuestOfferwallTypes: [],
            newOfferwallType: '',

            // 충전소 관리 - OFFERWALL_LIST
            OFFERWALL_TOP_COUNT: 8,
            offerwall_list: [],
            offerwallDialog: false,
            savingOfferwall: false,
            showAllOfferwalls: false,
            editingOfferwall: { name: '', tag: '', icon: '', iconFile: null, is_active: 'Y', is_event_mode: 'N', event_start: '', event_end: '' },
            editingOfferwallIndex: -1,
            startMenuOfw: false,   // 충전소 이벤트 시작 날짜/시간 피커 메뉴
            endMenuOfw: false,     // 충전소 이벤트 종료 날짜/시간 피커 메뉴

            // 충전소 탭 관리 - CHARGE_TAB_LIST
            charge_tab_list: [],
            // 황금동상 오퍼월 관리 - GOLDEN_STATUE_OFFERWALL_LIST (충전소관리 오퍼월을 tag 로 참조)
            golden_statue_offerwall_list: [],
            addGoldenStatueTagSelector: null,
            chargeTabDialog: false,
            savingChargeTab: false,
            chargeTabTypeOptions: [
                { text: 'PLACEMENT_BIG (큰 플레이스먼트)', value: 'PLACEMENT_BIG' },
                { text: 'PLACEMENT_NORMAL (일반 플레이스먼트)', value: 'PLACEMENT_NORMAL' },
                { text: 'OFFERWALL (충전소 관리에서 선택)', value: 'OFFERWALL' },
            ],
            editingChargeTab: { type: 'PLACEMENT_BIG', name: '', description: '', placement_key: '', icon: '', iconFile: null, limit_count: -1, offerwall_tags: [] },
            editingChargeTabIndex: -1,
            addOfferwallTagSelector: null,

            // 디버깅 - 디버그 유저 리스트
            debugUserIds: [],
            newDebugUserId: '',

            // 디버깅 - 클라이언트 로그
            logSearchUserId: '',
            logFetchCount: 50,
            clientLogs: [],
            loadingClientLogs: false,
            clientLogHeaders: [
                { text: 'PID', value: 'PID', width: '80px' },
                { text: 'USER_ID', value: 'USER_ID', width: '150px' },
                { text: 'LOG_TEXT', value: 'LOG_TEXT' },
                { text: '일시', value: 'CREATE_DT', width: '170px' },
                { text: '', value: 'actions', width: '90px', sortable: false },
            ],
            dialogLogDetail: false,
            selectedLog: null,
        }),

        created() {
            this.initializeFieldData();
            this.LoadGameSetting();
            this.getServerTime()
        },

        methods: {
            async onRestartServer() {
                if (!confirm('서버를 재시작하시겠습니까? 진행중인 작업이 중단될 수 있습니다.')) return;
                try {
                    await this.CARRYGOLD_PM2_RESTART();
                    alert('서버 재시작 요청이 완료되었습니다.');
                } catch (err) {
                    console.error(err);
                    alert('서버 재시작에 실패했습니다.');
                }
            },
            ...mapActions([
                'CARRYGOLD_PM2_RESTART',
                'GET_CLIENT_LOG_LIST',
            ]),
            
            /**
             * 필드 설정을 기반으로 fieldData 초기화
             */
            initializeFieldData() {
                this.fieldConfig.forEach(section => {
                    section.groups.forEach(group => {
                        group.fields.forEach(field => {
                            // 기본값으로 초기화
                            if (Array.isArray(field.default)) {
                                this.$set(this.fieldData, field.jsonKey, JSON.parse(JSON.stringify(field.default)));
                            } else {
                                this.$set(this.fieldData, field.jsonKey, field.default);
                            }
                        });
                    });
                });
                
                // 특수 필드도 초기화 (이벤트 썸네일 리스트는 data에서 초기화됨)
            },

            /**
             * 옵션 리스트 가져오기
             */
            getOptions(optionKey) {
                return this[optionKey] || [];
            },

            /**
             * JSON 데이터를 fieldData에 자동 로드
             */
            loadFieldsFromJson(jsonData) {
                this.fieldConfig.forEach(section => {
                    section.groups.forEach(group => {
                        group.fields.forEach(field => {
                            const jsonValue = jsonData[field.jsonKey];
                            if (jsonValue !== undefined) {
                                if (Array.isArray(jsonValue)) {
                                    this.$set(this.fieldData, field.jsonKey, JSON.parse(JSON.stringify(jsonValue)));
                                } else {
                                    this.$set(this.fieldData, field.jsonKey, jsonValue);
                                }
                            }
                        });
                    });
                });
                
                // 강제 업데이트(최소버전) 원본 스냅샷 (저장 시 변경 확인용)
                this._origForceVer = { aos: String(this.fieldData.VERSION_AOS_MIN || '').trim(), ios: String(this.fieldData.VERSION_IOS_MIN || '').trim() };

                // 특수 필드 처리
                if (jsonData.EVENT_THUMB_LIST) {
                    // 빈 배열 fallback 제거 — 서버에 비어있으면 그대로 비어있게 유지
                    this.event_thumb_list = JSON.parse(JSON.stringify(jsonData.EVENT_THUMB_LIST));
                } else {
                    this.event_thumb_list = [];
                }
                // 스탬프 이벤트 토글
                this.enable_stamp_event_tyr = (jsonData.ENABLE_STAMP_EVENT_TYR === 'Y') ? 'Y' : 'N';
                this.enable_stamp_event_maf = (jsonData.ENABLE_STAMP_EVENT_MAF === 'Y') ? 'Y' : 'N';
                // 일일 오퍼월 챌린지 카운트 설정 (기본 8)
                this.daily_offerwall_challenge_count = (jsonData.DAILY_OFFERWALL_CHALLENGE_COUNT !== undefined && jsonData.DAILY_OFFERWALL_CHALLENGE_COUNT !== null && jsonData.DAILY_OFFERWALL_CHALLENGE_COUNT !== '') ? Number(jsonData.DAILY_OFFERWALL_CHALLENGE_COUNT) : 8;
                if (jsonData.EVENT_OFFERWALL_GUIDE_LIST) {
                    this.event_offerwall_guide_list = JSON.parse(JSON.stringify(jsonData.EVENT_OFFERWALL_GUIDE_LIST));
                    this.event_offerwall_guide_list_count = this.event_offerwall_guide_list.length || 1;
                }
                if (jsonData.BOOSTER_QUEST_OFFERWALL_TYPES) {
                    this.boosterQuestOfferwallTypes = JSON.parse(JSON.stringify(jsonData.BOOSTER_QUEST_OFFERWALL_TYPES));
                }
                if (jsonData.DEBUG_USER_IDS) {
                    this.debugUserIds = JSON.parse(JSON.stringify(jsonData.DEBUG_USER_IDS));
                }
                if (Array.isArray(jsonData.OFFERWALL_LIST)) {
                    this.offerwall_list = JSON.parse(JSON.stringify(jsonData.OFFERWALL_LIST)).map((it) => ({
                        name: it.name || '',
                        tag: it.tag || '',
                        icon: it.icon || '',
                        iconFile: null,
                        is_active: it.is_active || 'Y',
                        is_event_mode: it.is_event_mode || 'N',
                        event_start: it.event_start || '',
                        event_end: it.event_end || '',
                    }));
                } else {
                    this.offerwall_list = [];
                }
                if (Array.isArray(jsonData.CHARGE_TAB_LIST)) {
                    this.charge_tab_list = JSON.parse(JSON.stringify(jsonData.CHARGE_TAB_LIST)).map((it) => {
                        const tags = Array.isArray(it.offerwall_tags)
                            ? it.offerwall_tags.filter((t) => !!t)
                            : (it.offerwall_tag ? [it.offerwall_tag] : []);
                        return {
                            type: it.type || 'PLACEMENT_NORMAL',
                            name: it.name || '',
                            description: it.description || '',
                            placement_key: it.placement_key || '',
                            icon: it.icon || '',
                            iconFile: null,
                            limit_count: typeof it.limit_count === 'number' ? it.limit_count : -1,
                            offerwall_tags: tags,
                        };
                    });
                } else {
                    this.charge_tab_list = [];
                }
                if (Array.isArray(jsonData.GOLDEN_STATUE_OFFERWALL_LIST)) {
                    this.golden_statue_offerwall_list = jsonData.GOLDEN_STATUE_OFFERWALL_LIST.filter((t) => typeof t === 'string' && t);
                } else {
                    this.golden_statue_offerwall_list = [];
                }
                // 전면광고 관리 — 플레이스먼트별 광고 타입 (INTERSTITIAL_AD_PLACEMENTS 객체 우선, 없으면 과거 루트 저장값 fallback)
                const adPlacements = jsonData.INTERSTITIAL_AD_PLACEMENTS || {};
                const pickAdType = (k) => (adPlacements[k] != null ? adPlacements[k] : (jsonData[k] || ''));
                this.ad_placement_values = {
                    CUP_EVENT:        pickAdType('CUP_EVENT'),
                    FRIEND_GATHER_AI: pickAdType('FRIEND_GATHER_AI'),
                    FRIEND_GATHER:    pickAdType('FRIEND_GATHER'),
                    WALLET_SAVE:      pickAdType('WALLET_SAVE'),
                    OX_SUBMIT:        pickAdType('OX_SUBMIT'),
                    OX_WRONG:         pickAdType('OX_WRONG'),
                    TOKEN_ATTENDANCE: pickAdType('TOKEN_ATTENDANCE'),
                    TOKEN_SAVE:       pickAdType('TOKEN_SAVE'),
                };
            },

            async LoadGameSetting() {
                const timestamp = new Date().getTime();
                const url = this.serverState_URL+`?t=${timestamp}`;
                console.log(url);
                try {
                    const response = await fetch(url, {
                        method: 'GET',
                        cache: 'no-store'
                    });

                    const data = await response.json();
                    console.log("데이터 불러옴"+JSON.stringify(data));
                    
                    // 필드 매핑을 사용하여 자동으로 로드
                    this.loadFieldsFromJson(data);
                    
                } catch (error) {
                    console.error('JSON 파일 가져오기 실패:', error);
                }
            },

            /**
             * fieldData를 JSON으로 변환
             */
            MakeSettingData_Json() {
                const result_server_state = {
                    "PACKAGE": "io.snapplay.carrygold",
                    "NAME": "금나르기",
                    "SERVICE_OPTION": {
                        "item_opt": [
                                    {
                                    "key": "10001",
                                    "name": "CPU 증가 보너스 포인트"
                                    }
                                ]
                    }
                };

                // 필드 설정을 순회하며 자동으로 값 할당
                this.fieldConfig.forEach(section => {
                    section.groups.forEach(group => {
                        group.fields.forEach(field => {
                            result_server_state[field.jsonKey] = this.fieldData[field.jsonKey];
                        });
                    });
                });

                // 특수 필드
                result_server_state["EVENT_THUMB_LIST"] = this.event_thumb_list;
                // 스탬프 이벤트 토글 ('Y'/'N')
                result_server_state["ENABLE_STAMP_EVENT_TYR"] = (this.enable_stamp_event_tyr === 'Y') ? 'Y' : 'N';
                result_server_state["ENABLE_STAMP_EVENT_MAF"] = (this.enable_stamp_event_maf === 'Y') ? 'Y' : 'N';
                // 일일 오퍼월 챌린지 카운트 설정
                result_server_state["DAILY_OFFERWALL_CHALLENGE_COUNT"] = Number(this.daily_offerwall_challenge_count) || 8;
                result_server_state["REVIEW_EVENT_LINK"] = this.fieldData.REVIEW_EVENT_LINK_AOS;
                result_server_state["REVIEW_EVENT_LINK_REVIEW"] = this.fieldData.REVIEW_EVENT_LINK_IOS;
                result_server_state["BOOSTER_QUEST_OFFERWALL_TYPES"] = this.boosterQuestOfferwallTypes;
                result_server_state["DEBUG_USER_IDS"] = this.debugUserIds;
                result_server_state["OFFERWALL_LIST"] = this.offerwall_list.map((it) => ({
                    name: it.name,
                    tag: it.tag || '',
                    icon: it.icon || '',
                    is_active: it.is_active || 'Y',
                    is_event_mode: it.is_event_mode || 'N',
                    event_start: it.event_start || '',
                    event_end: it.event_end || '',
                }));
                result_server_state["CHARGE_TAB_LIST"] = this.charge_tab_list.map((it) => {
                    if (it.type === 'OFFERWALL') {
                        return {
                            type: 'OFFERWALL',
                            offerwall_tags: Array.isArray(it.offerwall_tags) ? it.offerwall_tags.filter((t) => !!t) : [],
                        };
                    }
                    return {
                        type: it.type,
                        name: it.name || '',
                        description: it.description || '',
                        placement_key: it.placement_key || '',
                        limit_count: typeof it.limit_count === 'number' ? it.limit_count : -1,
                    };
                });
                result_server_state["GOLDEN_STATUE_OFFERWALL_LIST"] = this.golden_statue_offerwall_list.slice();
                // 전면광고 관리 — 플레이스먼트별 광고 타입 (하나의 객체로 묶어 저장)
                result_server_state["INTERSTITIAL_AD_PLACEMENTS"] = { ...this.ad_placement_values };

                return result_server_state;
            },

            IsActiveState(_item) {
                return _item.active_yn == "Y" ? true : false;
            },

            async OnSaveDone() {
                // 강제 업데이트(최소버전) 값이 변경되면 한 번 더 확인 (실수 방지)
                {
                    const _o = this._origForceVer || { aos: '', ios: '' };
                    const _ca = String(this.fieldData.VERSION_AOS_MIN == null ? '' : this.fieldData.VERSION_AOS_MIN).trim();
                    const _ci = String(this.fieldData.VERSION_IOS_MIN == null ? '' : this.fieldData.VERSION_IOS_MIN).trim();
                    if (String(_o.aos).trim() !== _ca || String(_o.ios).trim() !== _ci) {
                        if (!confirm('⚠️ 강제 업데이트(최소) 버전이 변경되었습니다.\n\nAOS: ' + (_o.aos || '(없음)') + ' → ' + (_ca || '(없음)') + '\niOS: ' + (_o.ios || '(없음)') + ' → ' + (_ci || '(없음)') + '\n\n이 버전 미만 유저는 강제 업데이트됩니다. 정말 저장하시겠습니까?')) {
                            return;
                        }
                    }
                    this._origForceVer = { aos: _ca, ios: _ci };
                }
                // 빈 항목(제목·설명·썸네일·param 전부 빈) 은 저장 페이로드에서 제외 — 잘못 들어간 빈 행 방어
                this.event_thumb_list = this.event_thumb_list.filter(it => {
                    if (!it) return false;
                    const hasContent = (it.title && String(it.title).trim())
                                    || (it.desc && String(it.desc).trim())
                                    || (it.thumb && String(it.thumb).trim())
                                    || (it.param && String(it.param).trim());
                    return !!hasContent;
                });

                // 이벤트 썸네일 이미지 업로드
                for (let i = 0; i < this.event_thumb_list.length; i++) {
                    const item = this.event_thumb_list[i];
                    const fileInput = this.$refs[`thumb_file_${i}`];
                    if (fileInput && fileInput.length > 0 && fileInput[0].$refs.input.files.length > 0) {
                        const file = fileInput[0].$refs.input.files[0];
                        const thumbPath = "carrygold/coin/images/"+this.Utill_CreateNewImageName(file.name);
                        await FileUpload_Async(file, thumbPath);
                        item.thumb = thumbPath;
                    }
                }

                const json_container = this.MakeSettingData_Json();
                console.log("저장:"+JSON.stringify(json_container));
                this.loadingData = true;
                var file_path = config.isLive?"carrygold/manage/live/ServerState.json":"carrygold/manage/dev/ServerState.json"
                if(await FileUpload_JSON(json_container, file_path)) {
                    this.loadingData = false;
                    console.log(`s3 서버에 저장 되었습니다. ${file_path}`);
                    // 설정 반영을 위해 setting_data_refresh 호출 (CORS 회피를 위해 CMS 백엔드 경유)
                    try {
                        const refreshUrl = `${config.getBackendUrl}/api/carrygold/setting_data_refresh`;
                        const refreshRes = await axios.post(refreshUrl, { is_live: config.isLive });
                        console.log('[setting_data_refresh] 호출 결과:', refreshRes.data);
                    } catch (err) {
                        console.warn('[setting_data_refresh] 호출 실패:', err?.response?.data ?? err.message);
                    }
                    alert("저장완료");
                }   
            },

            Refresh_ItemInfo() {},
            
            IsSever_Checking() {
                return this.fieldData.SERVER_STATE_IOS == '2' || this.fieldData.SERVER_STATE_AOS == '2';
            },

            addOfferwallGuide_Count(){
                this.event_offerwall_guide_list_count++;
                this.event_offerwall_guide_list.push({ placement: '', grade: '', reward: '' });
            },

            removeOfferwallGuide(index){
                this.event_offerwall_guide_list.splice(index, 1);
                this.event_offerwall_guide_list_count = this.event_offerwall_guide_list.length;
            },

            Utill_CreateNewImageName(originalFileName) {
                const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.'));
                const randomString = Math.random().toString(36).substring(2, 18);
                return randomString + fileExtension;
            },

            // ===== 충전소(OFFERWALL_LIST) 관리 =====
            getOfferwallItemStyle(item, index) {
                const inactive = item.is_active !== 'Y';
                const isTop = index < this.OFFERWALL_TOP_COUNT;
                const baseBorder = '1px solid #e0d8b8';
                if (inactive) {
                    return `background-color: #f5f5f5; opacity: 0.6; border: 1px solid #e0e0e0; border-radius: 6px;`;
                }
                if (isTop) {
                    // 아이보리 (상단 노출 활성)
                    return `background-color: #FFFDE7; border: ${baseBorder}; border-radius: 6px;`;
                }
                return `background-color: #FAFAFA; border: 1px solid #eeeeee; border-radius: 6px;`;
            },
            openOfferwallDialog() {
                this.editingOfferwall = { name: '', tag: '', icon: '', iconFile: null, is_active: 'Y', is_event_mode: 'N', event_start: '', event_end: '' };
                this.editingOfferwallIndex = -1;
                this.offerwallDialog = true;
            },
            editOfferwall(index) {
                const src = this.offerwall_list[index] || {};
                this.editingOfferwall = {
                    name: src.name || '',
                    tag: src.tag || '',
                    icon: src.icon || '',
                    iconFile: null,
                    is_active: src.is_active || 'Y',
                    is_event_mode: src.is_event_mode || 'N',
                    event_start: src.event_start || '',
                    event_end: src.event_end || '',
                };
                this.editingOfferwallIndex = index;
                this.offerwallDialog = true;
            },
            closeOfferwallDialog() {
                this.offerwallDialog = false;
                this.editingOfferwall = { name: '', tag: '', icon: '', iconFile: null, is_active: 'Y', is_event_mode: 'N', event_start: '', event_end: '' };
                this.editingOfferwallIndex = -1;
            },
            // 이벤트 모드가 켜져있어도, 기간(시작/종료)이 제대로 설정되고 현재 시각이 그 안일 때만 ON.
            // 시작 또는 종료가 미설정/무효이면 리스트에서는 OFF로 본다.
            isOfferwallEventActiveNow(item) {
                if (!item || item.is_event_mode !== 'Y') return false;
                if (!item.event_start || !item.event_end) return false;
                const s = new Date(String(item.event_start).replace(' ', 'T'));
                const e = new Date(String(item.event_end).replace(' ', 'T'));
                if (isNaN(s.getTime()) || isNaN(e.getTime())) return false;
                const now = new Date();
                if (now < s || now > e) return false;
                return true;
            },
            formatOfferwallEventPeriod(item) {
                const fmt = (v) => (v ? String(v).replace('T', ' ') : '미설정');
                return `${fmt(item.event_start)} ~ ${fmt(item.event_end)}`;
            },
            // date/time 피커 값을 합쳐 'YYYY-MM-DD HH:mm:ss' 로 저장. 날짜 없으면 비움, 시간 없으면 00:00:00.
            _setEventPart(objName, field, dateVal, timeVal) {
                const obj = this[objName];
                const cur = (obj[field] || '').replace('T', ' ');
                const parts = cur.split(' ');
                let d = parts[0] || '';
                let t = parts[1] || '';
                if (dateVal !== null && dateVal !== undefined) d = dateVal;
                if (timeVal !== null && timeVal !== undefined) t = timeVal;
                if (!d) { this.$set(obj, field, ''); return; }
                const tp = (t || '').split(':');
                const hh = (tp[0] || '00').padStart(2, '0');
                const mm = (tp[1] || '00').padStart(2, '0');
                const ss = (tp[2] || '00').padStart(2, '0');
                this.$set(obj, field, d + ' ' + hh + ':' + mm + ':' + ss);
            },
            clearOfwEvent(field) {
                this.$set(this.editingOfferwall, field, '');
            },
            async saveOfferwall() {
                if (!this.editingOfferwall.name || !this.editingOfferwall.name.trim()) {
                    alert('충전소 이름을 입력해주세요.');
                    return;
                }
                this.savingOfferwall = true;
                try {
                    if (this.editingOfferwall.iconFile != null) {
                        const iconPath = "carrygold/coin/images/" + this.Utill_CreateNewImageName(this.editingOfferwall.iconFile.name);
                        await FileUpload_Async(this.editingOfferwall.iconFile, iconPath);
                        this.editingOfferwall.icon = iconPath;
                    }
                    const payload = {
                        name: this.editingOfferwall.name.trim(),
                        tag: (this.editingOfferwall.tag || '').trim(),
                        icon: this.editingOfferwall.icon || '',
                        iconFile: null,
                        is_active: this.editingOfferwall.is_active || 'Y',
                        is_event_mode: this.editingOfferwall.is_event_mode || 'N',
                        event_start: this.editingOfferwall.event_start || '',
                        event_end: this.editingOfferwall.event_end || '',
                    };
                    if (this.editingOfferwallIndex >= 0) {
                        this.$set(this.offerwall_list, this.editingOfferwallIndex, payload);
                    } else {
                        this.offerwall_list.push(payload);
                    }
                    this.closeOfferwallDialog();
                } catch (err) {
                    console.error('충전소 저장 실패:', err);
                    alert('아이콘 업로드 또는 저장 중 오류가 발생했습니다.');
                } finally {
                    this.savingOfferwall = false;
                }
            },
            deleteOfferwall(index) {
                const item = this.offerwall_list[index];
                const name = (item && item.name) || '';
                if (confirm(`"${name}" 충전소를 삭제하시겠습니까?`)) {
                    this.offerwall_list.splice(index, 1);
                }
            },
            toggleOfferwallActive(index) {
                const item = { ...this.offerwall_list[index] };
                item.is_active = item.is_active === 'Y' ? 'N' : 'Y';
                this.$set(this.offerwall_list, index, item);
            },
            toggleOfferwallEventMode(index) {
                const item = { ...this.offerwall_list[index] };
                item.is_event_mode = item.is_event_mode === 'Y' ? 'N' : 'Y';
                this.$set(this.offerwall_list, index, item);
            },
            onOfferwallDragEnd() {
                console.log('충전소 순서 변경됨:', this.offerwall_list.map((it, i) => `${i}:${it.name}`));
            },

            // ===== 충전소 탭(CHARGE_TAB_LIST) 관리 =====
            getChargeTabTypeColor(type) {
                if (type === 'PLACEMENT_BIG') return 'deep-purple';
                if (type === 'PLACEMENT_NORMAL') return 'indigo';
                if (type === 'OFFERWALL') return 'orange darken-2';
                return 'grey';
            },
            getChargeTabItemStyle(item) {
                if (item.type === 'OFFERWALL') {
                    return 'background-color: #FFF8E1; border: 1px solid #FFE0B2; border-radius: 6px;';
                }
                if (item.type === 'PLACEMENT_BIG') {
                    return 'background-color: #EDE7F6; border: 1px solid #D1C4E9; border-radius: 6px;';
                }
                return 'background-color: #E8EAF6; border: 1px solid #C5CAE9; border-radius: 6px;';
            },
            resolveOfferwallByTag(tag) {
                if (!tag) return null;
                return this.offerwall_list.find((o) => o.tag === tag) || null;
            },
            // ===== 황금동상 오퍼월 관리 =====
            addGoldenStatueOfferwall(tag) {
                if (!tag) return;
                if (this.golden_statue_offerwall_list.indexOf(tag) < 0) {
                    this.golden_statue_offerwall_list.push(tag);
                }
                this.$nextTick(() => { this.addGoldenStatueTagSelector = null; });
            },
            removeGoldenStatueOfferwall(index) {
                this.golden_statue_offerwall_list.splice(index, 1);
            },
            getOfferwallTagsArray(item) {
                if (Array.isArray(item.offerwall_tags)) return item.offerwall_tags;
                if (item.offerwall_tag) return [item.offerwall_tag];
                return [];
            },
            getChargeTabName(item) {
                if (item.type === 'OFFERWALL') {
                    const tags = this.getOfferwallTagsArray(item);
                    if (!tags.length) return '(연결된 충전소 없음)';
                    const first = this.resolveOfferwallByTag(tags[0]);
                    const firstName = first ? (first.name || '(이름 없음)') : '(미연결)';
                    return tags.length === 1 ? firstName : `${firstName} 외 ${tags.length - 1}개`;
                }
                return item.name || '';
            },
            getChargeTabIcon(item) {
                if (item.type === 'OFFERWALL') {
                    const tags = this.getOfferwallTagsArray(item);
                    for (const tag of tags) {
                        const ow = this.resolveOfferwallByTag(tag);
                        if (ow && ow.icon) return ow.icon;
                    }
                    return '';
                }
                return item.icon || '';
            },
            openChargeTabDialog() {
                this.editingChargeTab = {
                    type: 'PLACEMENT_BIG',
                    name: '',
                    description: '',
                    placement_key: '',
                    icon: '',
                    iconFile: null,
                    limit_count: -1,
                    offerwall_tags: [],
                };
                this.editingChargeTabIndex = -1;
                this.addOfferwallTagSelector = null;
                this.chargeTabDialog = true;
            },
            editChargeTab(index) {
                const src = this.charge_tab_list[index] || {};
                this.editingChargeTab = {
                    type: src.type || 'PLACEMENT_NORMAL',
                    name: src.name || '',
                    description: src.description || '',
                    placement_key: src.placement_key || '',
                    icon: src.icon || '',
                    iconFile: null,
                    limit_count: typeof src.limit_count === 'number' ? src.limit_count : -1,
                    offerwall_tags: this.getOfferwallTagsArray(src).slice(),
                };
                this.editingChargeTabIndex = index;
                this.addOfferwallTagSelector = null;
                this.chargeTabDialog = true;
            },
            closeChargeTabDialog() {
                this.chargeTabDialog = false;
                this.editingChargeTab = {
                    type: 'PLACEMENT_BIG',
                    name: '',
                    description: '',
                    placement_key: '',
                    icon: '',
                    iconFile: null,
                    limit_count: -1,
                    offerwall_tags: [],
                };
                this.editingChargeTabIndex = -1;
                this.addOfferwallTagSelector = null;
            },
            addOfferwallToTab(tag) {
                if (!tag) return;
                if (this.editingChargeTab.offerwall_tags.indexOf(tag) < 0) {
                    this.editingChargeTab.offerwall_tags.push(tag);
                }
                this.$nextTick(() => { this.addOfferwallTagSelector = null; });
            },
            removeOfferwallFromTab(index) {
                this.editingChargeTab.offerwall_tags.splice(index, 1);
            },
            onOfferwallTagsDragEnd() {
                console.log('충전소 탭 내부 OFFERWALL 순서 변경됨:', this.editingChargeTab.offerwall_tags.slice());
            },
            async saveChargeTab() {
                const t = this.editingChargeTab.type;
                if (t === 'PLACEMENT_BIG' || t === 'PLACEMENT_NORMAL') {
                    if (!this.editingChargeTab.name || !this.editingChargeTab.name.trim()) {
                        alert('이름을 입력해주세요.');
                        return;
                    }
                    if (!this.editingChargeTab.placement_key || !this.editingChargeTab.placement_key.trim()) {
                        alert('플레이스먼트 키를 입력해주세요.');
                        return;
                    }
                } else if (t === 'OFFERWALL') {
                    if (!Array.isArray(this.editingChargeTab.offerwall_tags) || this.editingChargeTab.offerwall_tags.length === 0) {
                        alert('충전소를 1개 이상 추가해주세요.');
                        return;
                    }
                } else {
                    alert('탭 타입을 선택해주세요.');
                    return;
                }

                this.savingChargeTab = true;
                try {
                    let payload;
                    if (t === 'OFFERWALL') {
                        payload = {
                            type: 'OFFERWALL',
                            name: '',
                            description: '',
                            placement_key: '',
                            icon: '',
                            iconFile: null,
                            limit_count: -1,
                            offerwall_tags: this.editingChargeTab.offerwall_tags.slice(),
                        };
                    } else {
                        const lc = Number(this.editingChargeTab.limit_count);
                        payload = {
                            type: t,
                            name: this.editingChargeTab.name.trim(),
                            description: (this.editingChargeTab.description || '').trim(),
                            placement_key: this.editingChargeTab.placement_key.trim(),
                            icon: '',
                            iconFile: null,
                            limit_count: Number.isFinite(lc) ? lc : -1,
                            offerwall_tags: [],
                        };
                    }

                    if (this.editingChargeTabIndex >= 0) {
                        this.$set(this.charge_tab_list, this.editingChargeTabIndex, payload);
                    } else {
                        this.charge_tab_list.push(payload);
                    }
                    this.closeChargeTabDialog();
                } catch (err) {
                    console.error('충전소 탭 저장 실패:', err);
                    alert('아이콘 업로드 또는 저장 중 오류가 발생했습니다.');
                } finally {
                    this.savingChargeTab = false;
                }
            },
            deleteChargeTab(index) {
                const item = this.charge_tab_list[index];
                const label = item ? (item.type === 'OFFERWALL'
                    ? (this.getChargeTabName(item) + ' [OFFERWALL]')
                    : (item.name || item.type)) : '';
                if (confirm(`"${label}" 탭을 삭제하시겠습니까?`)) {
                    this.charge_tab_list.splice(index, 1);
                }
            },
            onChargeTabDragEnd() {
                console.log('충전소 탭 순서 변경됨:', this.charge_tab_list.map((it, i) => `${i}:${it.type}:${this.getChargeTabName(it)}`));
            },

            addEventThumbItem() {
                this.eventThumbEditIndex = -1;
                this.eventThumbDialogData = {
                    title: '',
                    desc: '',
                    location: 'main',
                    thumb: '',
                    type: 'link',
                    param: '',
                    sub_param: ''
                };
                this.eventThumbDialogTempFile = null;
                this.eventThumbDialog = true;
            },

            openEventThumbDialog(index) {
                this.eventThumbEditIndex = index;
                const item = this.event_thumb_list[index];
                this.eventThumbDialogData = {
                    title: item.title || '',
                    desc: item.desc || '',
                    location: item.location || 'main',
                    thumb: item.thumb || '',
                    type: item.type || 'link',
                    param: item.param || '',
                    sub_param: item.sub_param || ''
                };
                this.eventThumbDialogTempFile = null;
                this.eventThumbDialog = true;
            },

            closeEventThumbDialog() {
                this.eventThumbDialog = false;
                this.eventThumbEditIndex = -1;
                this.eventThumbDialogData = {
                    title: '',
                    desc: '',
                    location: 'main',
                    thumb: '',
                    type: 'link',
                    param: '',
                    sub_param: ''
                };
                this.eventThumbDialogTempFile = null;
            },

            // 이벤트 썸네일 타입 라벨/플레이스홀더 — link/placement/campaign/offerwall 4종 분기
            paramLabelFor(type) {
                if (type === 'placement') return '플레이스먼트 키';
                if (type === 'campaign')  return '캠페인 ID';
                if (type === 'offerwall') return '오퍼월 키';
                return '링크 URL';
            },
            paramPlaceholderFor(type) {
                if (type === 'placement') return 'ex: cpu_영자추천2';
                if (type === 'campaign')  return '예: 391630';
                if (type === 'offerwall') return '예: snapplay_offerwall';
                return 'https://...';
            },
            typeLabelFor(type) {
                if (type === 'placement') return '플레이스먼트';
                if (type === 'campaign')  return '캠페인';
                if (type === 'offerwall') return '오퍼월';
                return '링크';
            },

            async saveEventThumbDialog() {
                if (!this.eventThumbDialogData.title || !this.eventThumbDialogData.location) {
                    alert('타이틀과 공개위치는 필수 입력 항목입니다.');
                    return;
                }

                let thumbPath = this.eventThumbDialogData.thumb;
                
                // 새 이미지가 업로드된 경우
                if (this.eventThumbDialogTempFile) {
                    thumbPath = "carrygold/coin/images/"+this.Utill_CreateNewImageName(this.eventThumbDialogTempFile.name);
                    await FileUpload_Async(this.eventThumbDialogTempFile, thumbPath);
                }

                const itemData = {
                    title: this.eventThumbDialogData.title,
                    desc: this.eventThumbDialogData.desc,
                    location: this.eventThumbDialogData.location,
                    thumb: thumbPath,
                    type: this.eventThumbDialogData.type,
                    param: this.eventThumbDialogData.param,
                    // 캠페인 타입일 때만 sub_param 저장. 다른 타입은 빈 문자열로 정리.
                    sub_param: this.eventThumbDialogData.type === 'campaign'
                        ? (this.eventThumbDialogData.sub_param || '')
                        : ''
                };

                if (this.eventThumbEditIndex === -1) {
                    // 새 항목 추가
                    this.event_thumb_list.push(itemData);
                } else {
                    // 기존 항목 수정
                    this.$set(this.event_thumb_list, this.eventThumbEditIndex, itemData);
                }

                this.closeEventThumbDialog();
            },

            removeEventThumbItem(index) {
                if (confirm('이 이벤트를 삭제하시겠습니까?')) {
                    this.event_thumb_list.splice(index, 1);
                }
            },

            async getServerTime() {},

            onFileChange_BoosterQuest(file) {
                const f = Array.isArray(file) ? file[0] : file;
                if (!f) {
                    this.enableUpload_BoosterQuest = false;
                    return;
                }
                const reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        JSON.parse(e.target.result);
                        this.enableUpload_BoosterQuest = true;
                    } catch (err) {
                        alert('JSON 파일 형식이 올바르지 않습니다.');
                        this.enableUpload_BoosterQuest = false;
                    }
                };
                reader.readAsText(f, 'utf-8');
            },

            async upload_BoosterQuest() {
                if (!this.boosterQuestFile) return;
                const filePath = config.isLive
                    ? 'carrygold/data/live/booster_quest.json'
                    : 'carrygold/data/dev/booster_quest.json';
                const reader = new FileReader();
                reader.onload = async (e) => {
                    try {
                        const json = JSON.parse(e.target.result);
                        this.loadingBoosterQuest = true;
                        const success = await FileUpload_JSON(json, filePath);
                        this.loadingBoosterQuest = false;
                        if (success) {
                            try {
                                await axios.post('https://carrygoldapi.snapplay.io/carrygold/util/quest_data_refresh');
                                console.log('[quest_data_refresh] 호출 완료');
                            } catch (err) {
                                console.warn('[quest_data_refresh] 호출 실패:', err?.response?.data ?? err.message);
                            }
                            alert('부스터 퀘스트 업로드 완료');
                            this.boosterQuestFile = null;
                            this.enableUpload_BoosterQuest = false;
                        } else {
                            alert('업로드에 실패했습니다. 잠시 후 다시 시도해주세요.');
                        }
                    } catch (err) {
                        this.loadingBoosterQuest = false;
                        alert('파일을 읽는 중 오류가 발생했습니다.');
                    }
                };
                reader.readAsText(this.boosterQuestFile, 'utf-8');
            },

            openBoosterQuestLink() {
                const env = config.isLive ? 'live' : 'dev';
                const url = `https://content-filecenter.s3.ap-northeast-2.amazonaws.com/carrygold/data/${env}/booster_quest.json`;
                window.open(url, '_blank');
            },

            // ── 부스터 퀘스트 V2 ──
            onFileChange_BoosterQuestV2(f) {
                if (!f) {
                    this.enableUpload_BoosterQuestV2 = false;
                    return;
                }
                const reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        JSON.parse(e.target.result);
                        this.enableUpload_BoosterQuestV2 = true;
                    } catch (err) {
                        alert('V2 JSON 파일 형식이 올바르지 않습니다.');
                        this.enableUpload_BoosterQuestV2 = false;
                    }
                };
                reader.readAsText(f, 'utf-8');
            },

            async upload_BoosterQuestV2() {
                if (!this.boosterQuestFileV2) return;
                const filePath = config.isLive
                    ? 'carrygold/data/live/booster_quest_v2.json'
                    : 'carrygold/data/dev/booster_quest_v2.json';
                const reader = new FileReader();
                reader.onload = async (e) => {
                    try {
                        const json = JSON.parse(e.target.result);
                        this.loadingBoosterQuestV2 = true;
                        const success = await FileUpload_JSON(json, filePath);
                        this.loadingBoosterQuestV2 = false;
                        if (success) {
                            try {
                                await axios.post('https://carrygoldapi.snapplay.io/carrygold/util/quest_data_refresh');
                                console.log('[quest_data_refresh] V2 후 호출 완료');
                            } catch (err) {
                                console.warn('[quest_data_refresh] V2 호출 실패:', err?.response?.data ?? err.message);
                            }
                            alert('부스터 퀘스트 V2 업로드 완료');
                            this.boosterQuestFileV2 = null;
                            this.enableUpload_BoosterQuestV2 = false;
                        } else {
                            alert('V2 업로드에 실패했습니다. 잠시 후 다시 시도해주세요.');
                        }
                    } catch (err) {
                        this.loadingBoosterQuestV2 = false;
                        alert('V2 파일을 읽는 중 오류가 발생했습니다.');
                    }
                };
                reader.readAsText(this.boosterQuestFileV2, 'utf-8');
            },

            openBoosterQuestLinkV2() {
                const env = config.isLive ? 'live' : 'dev';
                const url = `https://content-filecenter.s3.ap-northeast-2.amazonaws.com/carrygold/data/${env}/booster_quest_v2.json`;
                window.open(url, '_blank');
            },

            addOfferwallType() {
                const val = (this.newOfferwallType || '').trim();
                if (!val) return;
                if (this.boosterQuestOfferwallTypes.includes(val)) {
                    alert('이미 등록된 타입입니다.');
                    return;
                }
                this.boosterQuestOfferwallTypes.push(val);
                this.newOfferwallType = '';
            },

            removeOfferwallType(idx) {
                this.boosterQuestOfferwallTypes.splice(idx, 1);
            },

            addDebugUserId() {
                const val = (this.newDebugUserId || '').trim();
                if (!val) return;
                if (this.debugUserIds.includes(val)) {
                    alert('이미 등록된 유저 아이디입니다.');
                    return;
                }
                this.debugUserIds.push(val);
                this.newDebugUserId = '';
            },

            removeDebugUserId(idx) {
                this.debugUserIds.splice(idx, 1);
            },

            async fetchClientLogs() {
                this.loadingClientLogs = true;
                try {
                    const params = { count: this.logFetchCount || 50 };
                    if (this.logSearchUserId && this.logSearchUserId.trim()) {
                        params.user_id = this.logSearchUserId.trim();
                    }
                    const body_data = await this.GET_CLIENT_LOG_LIST(params);
                    console.log('ralph: GET_CLIENT_LOG_LIST response:', JSON.stringify(body_data, null, 2));
                    this.clientLogs = body_data.client_log_list || body_data.response_data?.client_log_list || [];
                } catch (err) {
                    console.error('fetchClientLogs error:', err);
                    alert('로그 조회에 실패했습니다.');
                    this.clientLogs = [];
                } finally {
                    this.loadingClientLogs = false;
                }
            },

            openLogDetail(item) {
                this.selectedLog = item;
                this.dialogLogDetail = true;
            },
        },

        computed: {
            // 모바일/태블릿에서는 탭 헤더 대신 드롭다운을 노출한다.
            // (가로 스크롤 중 스와이프가 탭 전환으로 잡히는 문제 방지)
            isMobileTab() {
                return this.$vuetify.breakpoint.smAndDown;
            },
            isLive() {
                return config.isLive;
            },
            serverState_URL() {
                return config.serverState_URL_CARRY_GOLD;
            },
            // 충전소 이벤트 시작/종료를 날짜(YYYY-MM-DD) + 시(HH) + 분(mm)으로 분해해 달력/드롭다운에 바인딩.
            // 저장 형식은 'YYYY-MM-DDTHH:mm' 유지. 날짜만 고르면 시간은 기본 00:00.
            hourItems() {
                return Array.from({ length: 24 }, (_, i) => { const v = String(i).padStart(2, '0'); return { text: v + '시', value: v }; });
            },
            minuteItems() {
                return Array.from({ length: 60 }, (_, i) => { const v = String(i).padStart(2, '0'); return { text: v + '분', value: v }; });
            },
            ofwStartDate: {
                get() { return (this.editingOfferwall.event_start || '').replace('T', ' ').split(' ')[0] || ''; },
                set(v) { this._setEventPart('editingOfferwall', 'event_start', v, null); },
            },
            ofwStartHour: {
                get() { return (((this.editingOfferwall.event_start || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[0]) || '00'; },
                set(v) { const m = (((this.editingOfferwall.event_start || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[1]) || '00'; this._setEventPart('editingOfferwall', 'event_start', null, v + ':' + m); },
            },
            ofwStartMin: {
                get() { return (((this.editingOfferwall.event_start || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[1]) || '00'; },
                set(v) { const h = (((this.editingOfferwall.event_start || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[0]) || '00'; this._setEventPart('editingOfferwall', 'event_start', null, h + ':' + v); },
            },
            ofwEndDate: {
                get() { return (this.editingOfferwall.event_end || '').replace('T', ' ').split(' ')[0] || ''; },
                set(v) { this._setEventPart('editingOfferwall', 'event_end', v, null); },
            },
            ofwEndHour: {
                get() { return (((this.editingOfferwall.event_end || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[0]) || '00'; },
                set(v) { const m = (((this.editingOfferwall.event_end || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[1]) || '00'; this._setEventPart('editingOfferwall', 'event_end', null, v + ':' + m); },
            },
            ofwEndMin: {
                get() { return (((this.editingOfferwall.event_end || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[1]) || '00'; },
                set(v) { const h = (((this.editingOfferwall.event_end || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[0]) || '00'; this._setEventPart('editingOfferwall', 'event_end', null, h + ':' + v); },
            },
            url() {
                return `${this.baseUrl}?t=${Date.now()}`;
            },
            offerwallSelectOptions() {
                return (this.offerwall_list || [])
                    .filter((o) => o && o.tag)
                    .map((o) => ({
                        label: `${o.name || '(이름 없음)'}  [tag: ${o.tag}]`,
                        value: o.tag,
                    }));
            },
            availableOfferwallOptions() {
                const selected = (this.editingChargeTab && this.editingChargeTab.offerwall_tags) || [];
                return this.offerwallSelectOptions.filter((o) => selected.indexOf(o.value) < 0);
            },
            // 황금동상: 추가된 태그를 실제 충전소 정보로 해석 (삭제된 충전소는 missing 표시)
            goldenStatueOfferwalls() {
                return (this.golden_statue_offerwall_list || []).map((tag) => {
                    const found = this.resolveOfferwallByTag(tag);
                    return found
                        ? { tag, name: found.name || '(이름 없음)', icon: found.icon || '', missing: false }
                        : { tag, name: tag, icon: '', missing: true };
                });
            },
            // 황금동상 추가용 옵션 (충전소관리 오퍼월 중 아직 추가 안 된 것)
            goldenStatueAvailableOptions() {
                const selected = this.golden_statue_offerwall_list || [];
                return this.offerwall_list
                    .filter((o) => o.tag && selected.indexOf(o.tag) < 0)
                    .map((o) => ({ label: o.name || o.tag, value: o.tag }));
            },
        },

        components: { draggable },
        watch: {
            '$store.state.selected_game_package': function () {
                console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
                this.LoadGameSetting();
                this.getServerTime()
            }
        }
    };
</script>

<style scoped>
.tab-item {
    min-width: 150px;
}

.tab-text {
    font-weight: 500;
    font-size: 0.9rem;
}

.toolbar-custom {
    border-bottom: 1px solid #e0e0e0;
}

.toolbar-title-custom {
    font-size: 1rem;
    font-weight: 600;
    color: #424242;
}

.toolbar-text {
    margin-left: 8px;
}

.tab-select {
    max-width: 100%;
    background-color: #fff;
}

@media (max-width: 960px) {
  .v-toolbar__content { flex-wrap: wrap; height: auto !important; padding: 8px; }
  .v-tabs { max-width: 100%; }
  .tab-select .tab-text { font-size: 0.875rem; }
}

/* ===== 폰(모바일) 대응: 리스트 행이 화면 안에 들어오고 액션(수정/삭제 등)이 잘리지 않게 ===== */
/* 내용 영역이 줄어들 수 있게(min-width:0) → 오른쪽 액션 버튼이 화면 밖으로 밀리지 않음 */
::v-deep .v-list-item__content { min-width: 0; }
::v-deep .v-list-item__title,
::v-deep .v-list-item__subtitle {
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
}
/* 액션(버튼 묶음)은 줄어들지 않게 */
::v-deep .v-list-item__action { flex-shrink: 0; }

@media (max-width: 600px) {
  /* 좁은 화면에선 리스트 행을 감싸서 액션 버튼을 아래 줄(우측 정렬)로 내려 항상 보이게 */
  ::v-deep .v-list-item { flex-wrap: wrap; }
  ::v-deep .v-list-item__action {
    width: 100%;
    min-width: 0 !important;
    flex-direction: row !important;
    justify-content: flex-end;
    margin: 4px 0 0 0 !important;
  }
}
</style>
